// these functions can be used without importing

import VueResource from "vue-resource"
import store from "../../store/index"
import axios from "axios"
import seasonFunctions from "./season.js"
import CryptoJS from "crypto-js"
import dataprocessing from "./dataprocessing"
import { applyPerfFlags, shareInflight, shareKey } from "./aiRequestDedupe"
export let montharray_complete = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
export let colorCodes = [
    "178, 245, 91", //grün
    "91, 138, 99", //dunkelgrün
    "91, 245, 232", //türkis
    "91, 121, 245", //blau
    "245, 242, 91", //gelb
    "245, 157, 91", //orange
    "245, 91, 101", //rot
    "152, 91, 245", //dunkellila
    "135, 156, 176", //grau
    "224, 91, 245" //notfallfarbe falls kein overall lila bäh
]
export let questionsParams = [
    {
        language: "de",
        questionParams: ["das", "dass", "der", "die", "wann", "warum", "was", "welche", "welcher", "welches", "wer", "wie", "wo", "wohin"],
        prepositionParams: ["ähnlich", "an", "auf", "bei", "bis", "für", "mit", "nach", "nahe", "ohne", "zu"],
        comparissonParams: ["gegen", "gleich", "oder", "und", "vs"]
    }
]
export let questionsColumn = {
    active: true,
    sortable: true,
    group: 0,
    text: "Type",
    modifiedText: "Type",
    value: "custom_Type",
    tooltip: "",
    modifiedTooltip: "",
    align: "left",
    custom: true,
    filter_attributes: [],
    customOptions: {
        type: "Dropdown",
        entries: []
    }
}

export let standardHeaders = [
    {
        active: true,
        sortable: true,
        canBeModified: true,
        modify: false,
        group: 0,
        custom: false,
        text: "Keyword",
        modifiedText: "Keyword",
        value: "keyword",
        tooltip: "The given search phrase",
        modifiedTooltip: "The given search phrase",
        width: "250",
        align: "left"
    },
    {
        active: false,
        sortable: true,
        modify: false,
        custom: false,
        group: 0,
        text: "Instagram Media Count",
        modifiedText: "Instagram Media Count",
        value: "media_count",
        tooltip: "Indicates how often this keyword is used as a hashtag on Instagram",
        modifiedTooltip: "Indicates how often this keyword is used as a hashtag on Instagram",
        width: "150",
        align: "left"
    },
    {
        active: true,
        sortable: true,
        canBeModified: true,
        modify: false,
        group: 0,
        custom: false,
        text: "Google Searches (Ø)",
        modifiedText: "Google Searches (Ø)",
        value: "avgsv",
        tooltip: "Represents the average search queries via google per month",
        modifiedTooltip: "Represents the average search queries via google per month",
        width: "150",
        align: "left"
    },
    {
        active: false,
        sortable: true,
        canBeModified: true,
        modify: false,
        group: 0,
        custom: false,
        text: "Google Searches (yearly)",
        modifiedText: "Google Searches (yearly)",
        value: "annualsv",
        tooltip: "Represents the search queries via google per year",
        modifiedTooltip: "Represents the search queries via google per year",
        width: "150",
        align: "left"
    },
    {
        active: true,
        sortable: false,
        canBeModified: true,
        modify: false,
        group: 0,
        custom: false,
        text: "Search Trend",
        modifiedText: "Search Trend",
        value: "trend",
        tooltip: "Represents the searches from january to december for each keyword",
        modifiedTooltip: "Represents the searches from january to december for each keyword",
        width: "80"
    },
    {
        active: true,
        sortable: false,
        canBeModified: true,
        modify: false,
        group: 0,
        text: "Categories",
        modifiedText: "Categories",
        value: "cats",
        tooltip: "Represents the product and service categories for each keyword",
        modifiedTooltip: "Represents the product and service categories for each keyword",
        width: "80"
    },
    // {
    //     active: true,
    //     sortable: true,
    //     canBeModified: true,
    //     modify: false,
    //     group: 0,
    //     custom: false,
    //     text: "CPC",
    //     modifiedText: "CPC",
    //     value: "adwords_cpc",
    //     tooltip: "Represents the average cost per click (EUR) historically paid for the keyword",
    //     modifiedTooltip: "Represents the average cost per click (EUR) historically paid for the keyword",
    //     width: "100",
    //     align: "left"
    // },

    {
        active: true,
        sortable: true,
        canBeModified: true,
        modify: false,
        group: 0,
        custom: false,
        text: "Keyword Difficulty",
        modifiedText: "Keyword Difficulty",
        value: "keyword_difficulty",
        tooltip: "Keyword difficulty is a measure of how much effort is required to get your content on the first page of search results. ",
        modifiedTooltip: "Keyword difficulty is a measure of how much effort is required to get your content on the first page of search results. ",
        width: "100",
        align: "mid"
    },
    {
        active: true,
        sortable: true,
        canBeModified: true,
        modify: false,
        group: 0,
        custom: false,
        text: "Paid Competition",
        modifiedText: "Paid Competition",
        value: "adwords_competition",
        tooltip: "Represents the relative amount of competition associated with the given keyword in paid google results only",
        modifiedTooltip: "Represents the relative amount of competition associated with the given keyword in paid google results only",
        width: "105",
        align: "mid"
    },
    {
        active: true,
        sortable: false,
        canBeModified: true,
        modify: false,
        group: 0,
        custom: false,
        text: "SERP Items",
        modifiedText: "SERP Items",
        value: "serp_items",
        tooltip: "SERP features represent the elements that constitute the search engine result page.",
        modifiedTooltip: "SERP features represent the elements that constitute the search engine result page.",
        width: "100",
        align: "left"
    },

    {
        active: true,
        sortable: true,
        canBeModified: true,
        modify: false,
        group: 0,
        custom: false,
        text: "CPC (Lower Range)",
        modifiedText: "CPC (Lower Range)",
        value: "adwords_cpc_low",
        tooltip:
            'The column "CPC Top Position (Lower Range)" contains the lower range of what advertisers have paid for upper position keyword bids in the past. The value is based on your location and search network settings. The average CPC of your keywords may vary.',
        modifiedTooltip:
            'The column "CPC Top Position (Lower Range)" contains the lower range of what advertisers have paid for upper position keyword bids in the past. The value is based on your location and search network settings. The average CPC of your keywords may vary.',
        width: "100",
        align: "left"
    },
    {
        active: true,
        sortable: true,
        canBeModified: true,
        modify: false,
        group: 0,
        custom: false,
        text: "CPC (Upper Range)",
        modifiedText: "CPC (Upper Range)",
        value: "adwords_cpc_high",
        tooltip:
            'The column "CPC Top Position (Upper Range)" contains the upper range of what advertisers have paid for upper position keyword bids in the past. The value is based on your location and search network settings. The average CPC of your keywords may vary.',
        modifiedTooltip:
            'The column "CPC Top Position (Upper Range)" contains the upper range of what advertisers have paid for upper position keyword bids in the past. The value is based on your location and search network settings. The average CPC of your keywords may vary.',
        width: "100",
        align: "left"
    },
    {
        active: false,
        sortable: true,
        canBeModified: true,
        modify: false,
        group: 0,
        custom: false,
        text: "Peak Month",
        modifiedText: "Peak Month",
        value: "peak",
        tooltip: "Strongest month of the past 12 months.",
        modifiedTooltip: "Strongest month of the past 12 months.",
        // width: "100",
        align: "left"
    },
    {
        active: false,
        sortable: true,
        canBeModified: true,
        modify: false,
        group: 0,
        custom: false,
        text: "Season",
        modifiedText: "Season",
        value: "season",
        tooltip: "The season is the strongest division of the year based on search volume.",
        modifiedTooltip: "The season is the strongest division of the year based on search volume.",
        // width: "130",
        align: "left"
    },
    {
        name: "sv_headers",
        active: true,
        columns: []
    }
]
export let positionColors = [
    "green darken-2",
    "light-green darken-2",
    "lime darken-2",
    "yellow darken-2",
    "orange darken-2",
    "deep-orange darken-2",
    "deep-orange darken-3",
    "red darken-2",
    "red darken-2",
    "red darken-4"
]
export let click_rates = [
    {
        position: "1",
        Desktop: 31.71,
        Mobile: 28.04
    },
    {
        position: "2",
        Desktop: 14.82,
        Mobile: 15.54
    },
    {
        position: "3",
        Desktop: 8.63,
        Mobile: 9.8
    },
    {
        position: "4",
        Desktop: 5.62,
        Mobile: 6.33
    },
    {
        position: "5",
        Desktop: 3.95,
        Mobile: 4.35
    },
    {
        position: "6",
        Desktop: 2.86,
        Mobile: 3.08
    },
    {
        position: "7",
        Desktop: 2.13,
        Mobile: 2.25
    },
    {
        position: "8",
        Desktop: 1.64,
        Mobile: 1.68
    },
    {
        position: "9",
        Desktop: 1.31,
        Mobile: 1.27
    },
    {
        position: "10",
        Desktop: 1.07,
        Mobile: 1.01
    },
    {
        position: "11",
        Desktop: 0.95,
        Mobile: 0.88
    },
    {
        position: "12",
        Desktop: 0.94,
        Mobile: 0.85
    },
    {
        position: "13",
        Desktop: 0.96,
        Mobile: 0.89
    },
    {
        position: "14",
        Desktop: 0.9,
        Mobile: 0.96
    },
    {
        position: "15",
        Desktop: 0.82,
        Mobile: 1.05
    },
    {
        position: "16",
        Desktop: 0.76,
        Mobile: 1.18
    },
    {
        position: "17",
        Desktop: 0.7,
        Mobile: 1.25
    },
    {
        position: "18",
        Desktop: 0.65,
        Mobile: 1.25
    },
    {
        position: "19",
        Desktop: 0.6,
        Mobile: 1.21
    },
    {
        position: "20",
        Desktop: 0.53,
        Mobile: 1.19
    }
]

// Passwortrichtlinie (siehe checkPasswordPolicy/isPasswordValid/passwordRule am Dateiende).
// Muss vor dem Default-Export stehen, weil das Objekt unten den Wert sofort liest.
const passwordPolicyText = "At least 12 characters, with uppercase and lowercase letters, a number and a special character."

export default {
    async addRankings(keywords, headers, language_code, location_code, domain, device) {
        try {
            if (!keywords || keywords.length == 0 || !domain) return
            //if domain is "example.com" add "www." to the domain
            domain = normalizeDomain(domain)
            console.log("add Rnakings")
            console.log("add Rnakings")
            console.log("add Rnakings")
            console.log("add Rnakings")
            console.log("add Rnakings")
            console.log("add Rnakings")
            console.log("add Rnakings")
            console.log("add Rnakings")
            console.log("add Rnakings")
            console.log("add Rnakings")
            console.log("add Rnakings")
            console.log("add Rnakings")
            console.log("add Rnakings")
            console.log("add Rnakings")
            console.log("add Rnakings")
            console.log("add Rnakings")
            console.log("add Rnakings")
            const company_id = CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(CryptoJS.enc.Utf8)
            console.log(device)
            const devices = ["mobile", "desktop", "tablet"]
            device = devices[device]
            const positionColors = [
                "green darken-2",
                "light-green darken-2",
                "lime darken-2",
                "yellow darken-2",
                "orange darken-2",
                "deep-orange darken-2",
                "deep-orange darken-3",
                "red darken-2",
                "red darken-2",
                "red darken-4"
            ]
            const rankingHeader = {
                active: true,
                sortable: true,
                canBeModified: true,
                modify: false,
                group: 0,
                custom: false,
                text: "Google Ranking",
                modifiedText: "Google Ranking",
                value: "ranking",
                tooltip: "Shows the position in google SERPs of the selected URL. Only if the keyword is currently monitored!",
                modifiedTooltip: "Shows the position in google SERPs of the selected URL. Only if the keyword is currently monitored!",
                width: "100"
            }
            const amazonSvHeader = {
                active: true,
                sortable: true,
                canBeModified: true,
                modify: false,
                group: 0,
                custom: false,
                text: "Amazon Search Volume (yearly)",
                modifiedText: "Amazon Search Volume (yearly)",
                value: "amazon_search_volume",
                tooltip: "Shows the position in google SERPs of the selected URL. Only if the keyword is currently monitored!",
                modifiedTooltip: "Shows the position in google SERPs of the selected URL. Only if the keyword is currently monitored!",
                width: "100"
            }
            const internalSearchSvHeader = {
                active: true,
                sortable: true,
                canBeModified: true,
                modify: false,
                group: 0,
                custom: false,
                text: "Internal Search Volume (Yearly)",
                modifiedText: "Internal Search Volume (Yearly)",
                value: "internal_search_volume",
                tooltip: "Shows the latest internal search volume for the matched internal searches project domain.",
                modifiedTooltip: "Shows the latest internal search volume for the matched internal searches project domain.",
                width: "120"
            }

            const url =
                (JSON.parse(process.env.VUE_APP_MONITORING_PROXY_COMPANY_IDS).indexOf(company_id) == -1 ? process.env.VUE_APP_MONITORING_API_URL : process.env.VUE_APP_APIURL + "/monitoring-api") +
                "/project/get/rankings-for-keywords/frontend"
            // const url = (JSON.parse(process.env.VUE_APP_MONITORING_PROXY_COMPANY_IDS).indexOf(
            //     this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)
            // ) == -1
            //     ? process.env.VUE_APP_MONITORING_API_URL
            //     : process.env.VUE_APP_APIURL + "/monitoring-api") + "/serp/get/latest/frontend"
            let keywords_array = keywords.map((keyword) => keyword.keyword)
            let postData = {
                company_id: localStorage.company_id,
                location_code: location_code,
                keywords_array: keywords_array,
                domain: domain,
                device: device
            }
            // console.log(keywords[0])
            keywords.map((k) => (k.ranking = null))
            let response_data = await this.axiosPost(url, postData)

            // console.log("addRankings", response_data.data)
            response_data.data.rankings.map((ranking) => {
                let kwEntry = keywords.find((keyword) => keyword.keyword == ranking.keyword)

                kwEntry.amazon_search_volume = ranking.amazon_search_volume || "-"
                kwEntry.ranking = ranking.ranking || {}
                kwEntry.ranking.datetime = ranking.datetime
                if (kwEntry.ranking.position) {
                    let colorIndex = Math.ceil(kwEntry.ranking.position / 10) - 1
                    let color = positionColors[colorIndex] ? positionColors[colorIndex] : positionColors[positionColors.length - 1]
                    kwEntry.ranking.color = color
                } else {
                    kwEntry.ranking.color = ""
                }
            })
            console.log(headers.modifiedHeaders.findIndex((h) => h.value == rankingHeader.value))
            let ranking_header_index = headers.modifiedHeaders.findIndex((h) => h.value == rankingHeader.value)
            if (ranking_header_index == -1) {
                headers.modifiedHeaders.splice(3, 0, rankingHeader)
            } else {
                headers.modifiedHeaders.splice(ranking_header_index, 1, rankingHeader)
            }
            if (company_id == "1547" || company_id == "1780" || company_id == "2") {
                let amazon_header_index = headers.modifiedHeaders.findIndex((h) => h.value == amazonSvHeader.value)
                if (amazon_header_index == -1) {
                    headers.modifiedHeaders.splice(4, 0, amazonSvHeader)
                } else {
                    headers.modifiedHeaders.splice(amazon_header_index, 1, amazonSvHeader)
                }
            }

            if (this.isInternalSearchEnabledForCompany(company_id)) {
                let projectsUrl = process.env.VUE_APP_APIURL + "/internal-searches/projects"
                let projectsResponse = await this.axiosPost(projectsUrl, { company_id: localStorage.company_id })
                let projects = projectsResponse && projectsResponse.data && projectsResponse.data.projects ? projectsResponse.data.projects : []

                const rawLanguageCode = String(language_code || "")
                const requestedLanguageCode = String(language_code || normalizeComparableDomain(domain).split(".").pop() || "")
                    .toLowerCase()
                    .trim()
                    .split("-")[0]
                    .split("_")[0]
                const requestedDomainNormalized = normalizeComparableDomain(domain)
                const requestedDomainCountryCode = requestedDomainNormalized.split(".").pop()

                const normalizeLanguageCode = (value) =>
                    String(value || "")
                        .toLowerCase()
                        .trim()
                        .split("-")[0]
                        .split("_")[0]

                const getDomainCountryCode = (value) => {
                    const normalized = normalizeComparableDomain(value)
                    return normalized ? normalized.split(".").pop() : ""
                }

                const getProjectLanguageMatchCode = (project) => {
                    const fromLanguageCode = normalizeLanguageCode(project?.language_code)
                    if (fromLanguageCode) return fromLanguageCode
                    return getDomainCountryCode(project?.domain)
                }

                console.log("[InternalSV][addRankings] match input", {
                    company_id,
                    domain,
                    rawLanguageCode,
                    requestedLanguageCode,
                    requestedDomainNormalized,
                    requestedDomainCountryCode,
                    projectsCount: projects.length
                })

                console.log(
                    "[InternalSV][addRankings] project candidates",
                    projects.map((project) => ({
                        id: project?._id,
                        domain: project?.domain,
                        language_code: project?.language_code,
                        normalized_domain: normalizeComparableDomain(project?.domain || ""),
                        normalized_language_code: normalizeLanguageCode(project?.language_code),
                        domain_country_code: getDomainCountryCode(project?.domain),
                        project_language_match_code: getProjectLanguageMatchCode(project)
                    }))
                )

                // 1) Primary match requested language code against project language code,
                //    or project domain country-code when language_code is not set.
                let selectedProject = projects.find((project) => getProjectLanguageMatchCode(project) == requestedLanguageCode)

                console.log("[InternalSV][addRankings] project language/domain-code match", {
                    requestedLanguageCode,
                    selectedProjectId: selectedProject?._id || null,
                    selectedProjectLanguageCode: selectedProject?.language_code || null,
                    selectedProjectDomain: selectedProject?.domain || null
                })

                // 2) Fallback: exact normalized domain
                if (!selectedProject) {
                    console.log("[InternalSV][addRankings] fallback to domain matching")
                    selectedProject = projects.find((project) => normalizeComparableDomain(project.domain || "") == normalizeComparableDomain(domain))
                }

                console.log("[InternalSV][addRankings] fallback result", {
                    requestedLanguageCode,
                    selectedProjectId: selectedProject?._id || null,
                    selectedProjectLanguageCode: selectedProject?.language_code || null
                })

                console.log("[InternalSV][addRankings] selected project after matching", {
                    selectedProjectId: selectedProject?._id || null,
                    selectedProjectDomain: selectedProject?.domain || null,
                    selectedProjectLanguageCode: selectedProject?.language_code || null
                })

                if (selectedProject && selectedProject._id) {
                    let searchesUrl = process.env.VUE_APP_APIURL + "/internal-searches/project/keywords/searches"
                    let searchesResponse = await this.axiosPost(searchesUrl, {
                        company_id: localStorage.company_id,
                        project_id: selectedProject._id,
                        keywords: keywords.map((keyword) => keyword.keyword)
                    })

                    let keywordSearches = Array.isArray(searchesResponse.data) ? searchesResponse.data : []
                    console.log("keywordSearches")
                    console.log("keywordSearches")
                    console.log("keywordSearches")
                    console.log("keywordSearches")
                    console.log(keywordSearches)
                    let latestDate = selectedProject.importDates && selectedProject.importDates.length ? selectedProject.importDates[0] : null
                    let svByKeyword = {}
                    const normalizeKeywordKey = (value) =>
                        String(value || "")
                            .toLowerCase()
                            .trim()
                            .replace(/\s+/g, " ")

                    keywordSearches.map((entry) => {
                        if (!entry || !entry._id || !Array.isArray(entry.data)) return
                        // sort data descending by importDate so index 0 is the most recent entry
                        let sortedData = [...entry.data].sort((a, b) => String(b.importDate || "").localeCompare(String(a.importDate || "")))
                        // Always use the actual newest data point as current and the next one as previous.
                        // Relying on project.importDates can be stale/out of sync with the real keyword data.
                        let selectedEntry = sortedData[0]
                        let previousEntry = sortedData[1]
                        svByKeyword[normalizeKeywordKey(entry._id)] = {
                            current: selectedEntry && selectedEntry.search_volume !== undefined ? selectedEntry.search_volume : "-",
                            previous: previousEntry && previousEntry.search_volume !== undefined ? previousEntry.search_volume : null
                        }
                    })
                    console.log(svByKeyword)
                    keywords.map((keyword) => {
                        let key = normalizeKeywordKey(keyword.keyword)
                        let svEntry = svByKeyword[key]
                        keyword.internal_search_volume = svEntry && svEntry.current !== undefined ? svEntry.current : "-"
                        keyword.internal_search_volume_prev = svEntry && svEntry.previous !== undefined ? svEntry.previous : null
                    })

                    let internal_sv_header_index = headers.modifiedHeaders.findIndex((h) => h.value == internalSearchSvHeader.value)
                    if (internal_sv_header_index == -1) {
                        headers.modifiedHeaders.splice(4, 0, internalSearchSvHeader)
                    } else {
                        headers.modifiedHeaders.splice(internal_sv_header_index, 1, internalSearchSvHeader)
                    }
                }
            }
        } catch (error) {
            console.log(error)
        }
    },
    isInternalSearchEnabledForCompany(company_id) {
        const defaults = ["2", "1547", "1780"]
        const fromEnv = (process.env.VUE_APP_INTERNAL_SEARCH_CUSTOMER_IDS || "")
            .split(",")
            .map((x) => x.trim())
            .filter(Boolean)
        let allowedIds = [...new Set([...defaults, ...fromEnv])]
        return allowedIds.includes(String(company_id))
    },
    /**
     * formats the keyword items from DFS for the keyword table
     * @param {*} dfsKeywords
     * @returns formatted keywords
     */
    formatDFSKeywords(dfsKeywords, allCategories) {
        return new Promise((resolve, reject) => {
            try {
                console.log(dfsKeywords[0])
                let formattedKeywords = dfsKeywords.map((dfsKeyword) => {
                    let keyword = {}

                    keyword.keyword = dfsKeyword.keyword
                    keyword.year = dfsKeyword.keyword_info.monthly_searches[0].year
                    keyword.month = dfsKeyword.keyword_info.monthly_searches[0].month
                    keyword.avgsv = dfsKeyword.keyword_info.search_volume
                    keyword.search_volumes = dfsKeyword.keyword_info.monthly_searches.map((svObj) => {
                        let obj = { count: svObj.search_volume, month: svObj.month, year: svObj.year }
                        return obj
                    })
                    keyword.dialog = false
                    keyword.categories = dataprocessing.translateCats(dfsKeyword.keyword_info.categories, allCategories)
                    keyword.adwords_cpc_high = dfsKeyword.keyword_info.high_top_of_page_bid
                    keyword.adwords_cpc_low = dfsKeyword.keyword_info.low_top_of_page_bid
                    keyword.active_cat_index = 0
                    keyword.adwords_competition = dfsKeyword.keyword_info.competition * 100
                    keyword.cats = dataprocessing.sortCats(keyword.categories)
                    keyword.serp_items = dataprocessing.getSERPItemsObject(dfsKeyword.serp_info ? dfsKeyword.serp_info.serp_item_types : null)
                    keyword.keyword_difficulty = dataprocessing.getDifficultyObject(dfsKeyword.keyword_properties ? dfsKeyword.keyword_properties.keyword_difficulty : null)

                    let monthly_searches = keyword.search_volumes
                    for (let monthCounter = 0; monthCounter < monthly_searches.length; monthCounter++) {
                        let svname = ""
                        if (monthly_searches[monthCounter].month < 10) {
                            svname = monthly_searches[monthCounter].year.toString() + "0" + monthly_searches[monthCounter].month.toString()
                        } else {
                            svname = monthly_searches[monthCounter].year.toString() + monthly_searches[monthCounter].month.toString()
                        }
                        keyword[svname] = parseInt(monthly_searches[monthCounter].count) || 0
                    }

                    return keyword
                })
                resolve(formattedKeywords)
            } catch (error) {
                reject(error)
            }
        })
    },
    /**
     * Entfernt Duplikate aus einem Array von Keyword-Objekten anhand der ersten 6 Monate aus search_volumes,
     * Levenshtein-Abstand und CPC-Werten.
     * @param {Array} keywords - Array von Keyword-Objekten
     * @param {Function} levenshteinDistance - Funktion zur Berechnung des Levenshtein-Abstands
     * @returns {Object} { deduped: Array, deleted: Array }
     */
    deduplicateKeywordsByMonths(keywords, levenshteinDistance) {
        let keywordData = [...keywords]
        let deleted = []

        // Sortiere nach avgsv absteigend, dann keyword absteigend
        keywordData = keywordData.sort((a, b) => {
            if (parseInt(b.avgsv) !== parseInt(a.avgsv)) {
                return parseInt(b.avgsv) - parseInt(a.avgsv)
            }
            const keywordA = a.keyword.toLowerCase()
            const keywordB = b.keyword.toLowerCase()
            if (keywordA < keywordB) return 1
            if (keywordA > keywordB) return -1
            return 0
        })

        for (let index = 0; index < keywordData.length; index++) {
            const row = keywordData[index]
            let i = index + 1
            for (; i <= Math.min(keywordData.length - 1, index + 5); i++) {
                const otherRow = keywordData[i]
                if (row.avgsv === otherRow.avgsv) {
                    // Vergleiche die ersten 6 Monate aus search_volumes
                    let monthsEqual = true
                    for (let m = 0; m < 6; m++) {
                        const rowMonth = row.search_volumes && row.search_volumes[m] ? row.search_volumes[m].count : null
                        const otherMonth = otherRow.search_volumes && otherRow.search_volumes[m] ? otherRow.search_volumes[m].count : null
                        if (rowMonth !== otherMonth) {
                            monthsEqual = false
                            break
                        }
                    }
                    if (monthsEqual) {
                        // Levenshtein-Logik
                        let levenshteinThreshold = row.keyword.length > 15 ? row.keyword.length * 0.2 : 3
                        const distance = levenshteinDistance ? levenshteinDistance(row.keyword, otherRow.keyword) : (a, b) => (a === b ? 0 : Math.abs(a.length - b.length))
                        let dist = typeof distance === "function" ? distance(row.keyword, otherRow.keyword) : distance

                        let low1 = parseFloat(row.adwords_cpc_low || 0)
                        let high1 = parseFloat(row.adwords_cpc_high || 0)
                        let low2 = parseFloat(otherRow.adwords_cpc_low || 0)
                        let high2 = parseFloat(otherRow.adwords_cpc_high || 0)

                        if ((low1 === low2 && high1 === high2) || (!row.adwords_cpc_low && !otherRow.adwords_cpc_low && !row.adwords_cpc_high && !otherRow.adwords_cpc_high)) {
                            row.grouped ? row.grouped.push(otherRow.keyword) : (row.grouped = [otherRow.keyword])
                            keywordData.splice(i, 1)
                            deleted.push({ k1: row.keyword, k2: otherRow.keyword, reason: "sv and cpc same", distance: dist })
                            i--
                        } else if (dist <= levenshteinThreshold) {
                            keywordData.splice(i, 1)
                            deleted.push({ k1: row.keyword, k2: otherRow.keyword, reason: "leven", distance: dist })
                            i--
                        }
                    }
                }
            }
        }
        return { deduped: keywordData, deleted }
    },
    formatDFSAdwordsKeywords(dfsKeywords, allCategories) {
        return new Promise(async (resolve, reject) => {
            try {
                console.log(dfsKeywords[0])
                let formattedKeywords = await Promise.all(
                    dfsKeywords.map(async (dfsKeyword) => {
                        let keyword = {}

                        keyword.keyword = dfsKeyword.keyword
                        keyword.year = dfsKeyword.monthly_searches ? dfsKeyword.monthly_searches[0].year : null
                        keyword.month = dfsKeyword.monthly_searches ? dfsKeyword.monthly_searches[0].month : null
                        keyword.avgsv = dfsKeyword.search_volume
                        if (dfsKeyword.monthly_searches) {
                            keyword.search_volumes = dfsKeyword.monthly_searches.map((svObj) => {
                                let obj = { count: svObj.search_volume, month: svObj.month, year: svObj.year }
                                return obj
                            })
                        } else {
                            let ans = JSON.parse(JSON.stringify(await this.buildSvObject(dfsKeyword, 48)))
                            keyword = ans
                        }
                        let annual = 0
                        for (let sumindex = 0; sumindex < 12; sumindex++) {
                            annual += keyword.search_volumes[sumindex].count ? keyword.search_volumes[sumindex].count : 0
                        }
                        ;(keyword.avgsv = parseInt(annual / 12)), console.log(keyword)

                        keyword.dialog = false
                        // keyword.categories = dataprocessing.translateCats(dfsKeyword.keyword_info.categories, allCategories)
                        keyword.adwords_cpc_high = dfsKeyword.high_top_of_page_bid
                        keyword.adwords_cpc_low = dfsKeyword.low_top_of_page_bid
                        keyword.active_cat_index = 0
                        keyword.adwords_competition = dfsKeyword.competition_index
                        // keyword.cats = dataprocessing.sortCats(keyword.categories)
                        // keyword.serp_items = dataprocessing.getSERPItemsObject(dfsKeyword.serp_info ? dfsKeyword.serp_info.serp_item_types : null)
                        // keyword.keyword_difficulty = dataprocessing.getDifficultyObject(dfsKeyword.keyword_properties ? dfsKeyword.keyword_properties.keyword_difficulty : null)

                        let monthly_searches = keyword.search_volumes
                        for (let monthCounter = 0; monthCounter < monthly_searches.length; monthCounter++) {
                            let svname = ""
                            if (monthly_searches[monthCounter].month < 10) {
                                svname = monthly_searches[monthCounter].year.toString() + "0" + monthly_searches[monthCounter].month.toString()
                            } else {
                                svname = monthly_searches[monthCounter].year.toString() + monthly_searches[monthCounter].month.toString()
                            }
                            keyword[svname] = parseInt(monthly_searches[monthCounter].count) || 0
                        }

                        return keyword
                    })
                )
                resolve(formattedKeywords)
            } catch (error) {
                reject(error)
            }
        })
    },
    notififcationErrorHandler(error_text = null, error_id = null) {
        return new Promise((resolve, reject) => {
            try {
                let errorNotificatons = [{ error_text: "no_credits_left", error_id: 0 }]

                if (error_id) {
                    resolve(errorNotificatons.find((error) => error.error_id == error_id))
                } else if (error_text) {
                    resolve(errorNotificatons.find((error) => error.error_text == error_text))
                }
                resolve([])
            } catch (error) {
                reject(error)
            }
        })
    },
    getRelevanceMinMaxValues(keywords) {
        return new Promise((resolve, reject) => {
            try {
                keywords = [...keywords].filter((keyword) => keyword.url_coverage !== undefined)
                let relevanceData = {}
                let wdfArray = keywords.map((keyword) => keyword.avgWDF)
                relevanceData.maxWDF = Math.max(...wdfArray)
                relevanceData.minWDF = Math.min(...wdfArray)

                let urlCovArray = keywords.map((keyword) => keyword.url_coverage)
                relevanceData.minURLCoverage = Math.min(...urlCovArray)
                relevanceData.maxURLCoverage = Math.max(...urlCovArray)

                // get MIn and MAx TermplacementValues
                let placementValueArray = [...new Set(keywords.map((keyword) => keyword.termplacementValue))]
                relevanceData.minPlacementValue = Math.min(...placementValueArray)
                relevanceData.maxPlacementValue = Math.max(...placementValueArray)
                resolve(relevanceData)
            } catch (error) {
                reject(error)
            }
        })
    },
    stringToBackgroundColor: function (str) {
        let hash = 0
        for (let i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash)
        }

        // Berechne die Farbkomponenten basierend auf dem Hash-Wert
        const c = (hash & 0x00ffffff).toString(16).toUpperCase()

        // Extrahiere die RGB-Komponenten
        const r = parseInt(c.slice(0, 2), 16)
        const g = parseInt(c.slice(2, 4), 16)
        const b = parseInt(c.slice(4, 6), 16)

        // Reduziere die Sättigung um einen bestimmten Prozentsatz (z.B. 30%)
        const saturationReductionPercentage = 30 // Ändere diesen Wert nach Bedarf
        const adjustedR = r + ((0 - r) * saturationReductionPercentage) / 100
        const adjustedG = g + ((0 - g) * saturationReductionPercentage) / 100
        const adjustedB = b + ((0 - b) * saturationReductionPercentage) / 100

        // Konvertiere die RGB-Werte zurück zu einem Hexadezimalwert
        const adjustedColor = (
            ("00" + Math.round(adjustedR).toString(16)).slice(-2) +
            ("00" + Math.round(adjustedG).toString(16)).slice(-2) +
            ("00" + Math.round(adjustedB).toString(16)).slice(-2)
        ).toUpperCase()

        // Gib die Farbe zurück (fülle ggf. mit Nullen auf, um 6 Zeichen zu erhalten)
        return "#" + adjustedColor
    },
    /**
     * adds season and peak to each keyword
     * @param {*} svArray
     * @param {*} sv
     * @returns
     */
    addPeakAndSeason: function (keywords) {
        keywords.map((keyword) => {
            let search_volumes_copy = JSON.parse(JSON.stringify(keyword.search_volumes)) // create save copy
            let svArray = search_volumes_copy.slice(0, 12) // get latest 12 entries for season
            if (!seasonFunctions.allValuesSame(svArray)) {
                // check if searchvolumes is the same in every month
                keyword.peak = seasonFunctions.addPeakMonth(svArray)
                keyword.season = seasonFunctions.addSeason(svArray)
            }
        })
    },

    /**
     * check if keywords are already in clipboard
     * @param {*} clipboard_keywords
     * @param {*} keywords
     * @returns
     */
    async keywordsInClipboard(keywords, clipboard_keywords) {
        try {
            keywords.map((keyword) => {
                let entry = clipboard_keywords.find((clipboard_keyword) => clipboard_keyword.keyword == keyword.keyword)
                if (entry) keyword.in_clipboard = true
            })
        } catch (error) {
            console.log(error)
        }
    },
    /**
     * check if keywords are already saved in a collection
     * @param {*} keywords
     * @param {*} company_id
     * @returns
     */
    fetchListsOfKeywords(keywords, company_id, loc) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = process.env.VUE_APP_APIURL + "/research/keywords-saved"
                let onlykeywords = keywords.map((keyword) => keyword.keyword)
                let post_data = { company_id: company_id, keywords: onlykeywords, loc: loc }
                let response_data = await this.axiosPost(url, post_data)
                keywords.map((keyword) => {
                    let entry = response_data.data.data.find((listentry) => listentry.keyword == keyword.keyword)
                    if (entry) keyword.lists = entry.lists
                })
                resolve(true)
            } catch (error) {
                console.log(error)
                resolve(true)
            }
        })
    },

    /**
     *
     * @param {*} url
     * @param {*} data
     * @returns
     */
    axiosPost(url, data, timeout = null) {
        // Identische, gleichzeitig laufende LESE-Anfragen der AI Suite werden zusammengelegt
        // (siehe aiRequestDedupe.js, dort steht auch, wie man es abschaltet). Fuer alle
        // anderen Routen ist der Schluessel null und es aendert sich nichts.
        data = applyPerfFlags(url, data)
        return shareInflight(
            shareKey(url, data),
            () =>
                new Promise(async (resolve, reject) => {
                    try {
                        let authsplits = process.env.VUE_APP_AUTH.split(":")
                        let config = {
                            method: "post",
                            url: url,
                            data: data,
                            auth: {
                                username: authsplits[0],
                                password: authsplits[1]
                            }
                        }
                        if (timeout) config.timeout = timeout
                        const response = await axios(config)
                        resolve(response)
                    } catch (error) {
                        reject(error)
                    }
                })
        )
    },

    /**
     * sets/changes primary category for keyword(s)
     * @param {Array} rows keyword(s) to modify
     * @param {Object} cat category to set
     */
    switchCat(rows, cat, keywords) {
        console.log("rows: ", rows)
        if (!rows || !cat) return
        rows.forEach((row) => {
            let rowindex = keywords.indexOf(row)
            if (!keywords[rowindex].cats) {
                // if keyword has no cats
                keywords[rowindex].cats = []
            }
            let catindex = keywords[rowindex].cats.findIndex((cat_entry) => cat_entry[cat_entry.length - 1].category_code == cat[cat.length - 1].category_code)
            if (catindex === -1) {
                // keyword does not have this category yet
                keywords[rowindex].cats.unshift(cat)
                catindex = 0
                // adding category and setting index
            }
            // set active category
            keywords[rowindex].active_cat_index = catindex
        })
    },
    buildSvObject(row, sv_length = 12) {
        return new Promise(async (resolve, reject) => {
            let actual_date = store.state.actual_date
            let endMonth = actual_date.split("/")[0]
            let endYear = actual_date.split("/")[1]
            let actual_date_number
            if (parseInt(endMonth) < 10) {
                actual_date_number = parseInt(endYear + "0" + endMonth)
            } else {
                actual_date_number = parseInt(endYear + "" + endMonth)
            }

            let monthCounter = actual_date_number
            row.search_volumes = []
            row.serp_items = null
            row.keyword_difficulty = null
            row.categories = []
            row.annualsv = 0
            row.avgsv = 0
            row.search_volumes = []
            row.dialog = false
            row.adwords_cpc_high = null
            row.adwords_cpc_low = null
            row.adwords_competition = 0
            row.active_cat_index = 0

            let done_months = 0
            do {
                // console.log(monthCounter)
                let helpingArray = []
                helpingArray.push(monthCounter.toString())
                let monthNumber = parseInt(helpingArray[0].slice(-2))
                let yearNumber = monthCounter.toString().slice(0, -2)

                let volume = {
                    count: 0,
                    year: parseInt(yearNumber),
                    month: parseInt(monthNumber)
                }
                row.search_volumes.push(volume)

                let svname = ""
                if (volume.month < 10) {
                    svname = volume.year.toString() + "0" + volume.month.toString()
                } else {
                    svname = volume.year.toString() + volume.month.toString()
                }
                row[svname] = 0
                monthCounter--
                done_months++
                if ((parseInt(monthNumber) % 12) - 1 == 0) {
                    monthCounter = monthCounter + 12 - 100
                }
            } while (done_months < sv_length)

            resolve(row)
        })
    },

    hexToRgb(hex) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
        if (result) {
            var r = parseInt(result[1], 16)
            var g = parseInt(result[2], 16)
            var b = parseInt(result[3], 16)
            return r + "," + g + "," + b //return 23,14,45 -> reformat if needed
        }
        return null
    },
    sumUpByAttribute(items, attribute) {
        return items.reduce(function (a, b) {
            return a + b[attribute]
        }, 0)
    },
    getInitials(name) {
        let splittedName = name.split(" ")
        let initials = ""
        splittedName.forEach((namepart) => {
            let firstletter = namepart.substring(0, 1)
            initials += firstletter
        })
        return initials
    },
    getIndexbyAttribute(myArray, item, attribute) {
        for (let index = 0; index < myArray.length; index++) {
            if (myArray[index][attribute] == item[attribute]) {
                return index
            }
        }
        return -1
    },

    isActionAllowed(right_id, rights) {
        // console.log(right_id)
        // console.log(rights)

        let found_rights = rights.find((x) => x.rightID === right_id)
        // console.log(found_rights)
        if (found_rights !== undefined || store.state.admin) {
            return true
        } else {
            return false
        }
    },
    /**
     * Password policy shown next to every password field in the app.
     */
    passwordPolicyText: passwordPolicyText,
    /**
     * Checks a password against the password policy and returns which rules are met.
     * @param {string} password
     * @returns {{length: boolean, uppercase: boolean, lowercase: boolean, number: boolean, special: boolean}}
     */
    checkPasswordPolicy: checkPasswordPolicy,
    /**
     * @param {string} password
     * @returns {boolean} true if the password fulfils the password policy
     */
    isPasswordValid: isPasswordValid,
    /**
     * Vuetify text-field rule for password fields. Bound to no `this` on purpose --
     * this is passed around detached as `:rules="[$helpers.passwordRule]"`, so it
     * must not rely on being called as a method on $helpers.
     * @param {string} password
     * @returns {boolean|string} true if valid, otherwise the error text
     */
    passwordRule: passwordRule,
    /**
     * shortens url if neccessary
     * @param {*} url
     * @returns
     */
    formatURL(url, length) {
        try {
            let urlobj = new URL(url)
            // console.log(urlobj)
            let formattedURL = urlobj.hostname.replace("www.", "") + urlobj.pathname
            return formattedURL.length > length ? formattedURL.substring(0, length) + "..." : formattedURL
        } catch (error) {
            return url
        }
    },
    getSparklineData(ranking, length = 0) {
        let svArray = []
        let svArrayCounter = 0
        for (let searchvolumesCounter = ranking.search_volumes.length - 1; searchvolumesCounter > -1; searchvolumesCounter--) {
            svArray[svArrayCounter] = ranking.search_volumes[searchvolumesCounter].count
            svArrayCounter++
        }
        if (length > 0) {
            try {
                return svArray.slice(svArray.length - length, svArray.length - 1)
            } catch (error) {
                return svArray
            }
        }
        return svArray
    },
    //Clean an Array
    cleanArray(myArray, callback) {
        return myArray.filter((e) => {
            return e != false && e !== null && e !== " " && e !== ""
        })
    },
    //Split an Array into chunks
    splitArray(myArray, chunk_size, callback) {
        var index = 0
        var tempArray = []
        for (index = 0; index < myArray.length; index += chunk_size) {
            myChunk = myArray.slice(index, index + chunk_size)
            tempArray.push(myChunk)
        }
        callback(tempArray)
    },
    //Remove duplicates from array of objects by attribute
    removeDuplicatesByAttribute(myArray, attribute) {
        let arrayWithoutDuplicates = myArray.filter((v, i, a) => a.findIndex((t) => t[attribute] === v[attribute]) === i)
        return arrayWithoutDuplicates
    },
    //Remove duplicates from array with levenstein distance
    removeDuplicatesByLeven(keywordData) {
        const levenshteinThreshold = 3
        const deleted = []
        for (let index = 0; index < keywordData.length; index++) {
            const row = keywordData[index]
            let i = index + 1
            for (i; i <= Math.min(keywordData.length - 1, index + 2); i++) {
                if (row.keyword !== keywordData[i].keyword) {
                    const otherRow = keywordData[i]
                    const distance = levenshteinDistance(row.keyword, otherRow.keyword)

                    if (distance <= levenshteinThreshold) {
                        deleted.push(keywordData.splice(i, 1))
                        i--
                    }
                }
            }
        }
        return deleted
    },

    getDateDiffText(date) {
        const now = new Date()
        const thens = new Date(date)
        const diffTime = Math.abs(now - thens)
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
        let updated_text
        if (diffDays > 365) {
            updated_text = "1 Year ago"
        } else if (diffDays >= 30) {
            updated_text = (diffDays / 30).toFixed(0)
            if (diffDays < 60) {
                updated_text += " month ago"
            } else {
                updated_text += " months ago"
            }
        } else if (diffDays >= 7) {
            updated_text = (diffDays / 7).toFixed(0)
            if (diffDays < 14) {
                updated_text += " week ago"
            } else {
                updated_text += " weeks ago"
            }
        } else {
            updated_text = diffDays
            if (diffDays < 2) {
                updated_text += " day ago"
            } else {
                updated_text += " days ago"
            }
        }
        return updated_text
    },
    addToClipboard(newKeywords, clipboardKeywords) {
        // getting db keywords of research
        var dbKeywords = clipboardKeywords
        // console.log(dbKeywords)

        for (let keywordCounter = 0; keywordCounter < newKeywords.length; keywordCounter++) {
            var keywordObject = dbKeywords.filter((x) => x.keyword == newKeywords[keywordCounter].keyword)
            // console.log("ound")
            // console.log(keywordObject[0])
            if (keywordObject[0] == undefined) {
                //keyword not in DB yet -> add to research
                clipboardKeywords.push(newKeywords[keywordCounter])
            } else {
                var frontendKeyword = newKeywords[keywordCounter]
                //overwrite clipboard cats with new frontend cats
                keywordObject[0].cats = frontendKeyword.cats

                for (let svCounter = 0; svCounter < frontendKeyword.search_volumes.length; svCounter++) {
                    for (let dbSvCounter = 0; dbSvCounter < keywordObject[0].search_volumes.length; dbSvCounter++) {
                        var dBMonthYearInt = 0
                        if (keywordObject[0].search_volumes[dbSvCounter].month < 10) {
                            dBMonthYearInt = keywordObject[0].search_volumes[dbSvCounter].year + "0" + keywordObject[0].search_volumes[dbSvCounter].month
                        } else {
                            dBMonthYearInt = keywordObject[0].search_volumes[dbSvCounter].year + "" + keywordObject[0].search_volumes[dbSvCounter].month
                        }
                        var frontendMonthYearInt = 0
                        if (frontendKeyword.search_volumes[svCounter].month < 10) {
                            frontendMonthYearInt = frontendKeyword.search_volumes[svCounter].year + "0" + frontendKeyword.search_volumes[svCounter].month
                        } else {
                            frontendMonthYearInt = frontendKeyword.search_volumes[svCounter].year + "" + frontendKeyword.search_volumes[svCounter].month
                        }
                        // console.log(dBMonthYearInt)
                        // console.log(frontendMonthYearInt)
                        if (parseInt(frontendMonthYearInt) == parseInt(dBMonthYearInt)) {
                            // console.log("Month found")

                            // sv found, comparing sv. if difference, google changed SV -> do nothing
                            // if(keyword.searchvolume[svCounter].volume == keywordObject.searchvolume[keywordObject.searchvolume.indexOf(keyword.searchvolume[svCounter])
                            break
                        } else {
                            if (parseInt(frontendMonthYearInt) > parseInt(dBMonthYearInt)) {
                                keywordObject[0].search_volumes.splice(dbSvCounter, 0, frontendKeyword.search_volumes[svCounter])
                                break
                            } else {
                                if (frontendMonthYearInt < dBMonthYearInt && dbSvCounter == keywordObject[0].search_volumes.length - 1) {
                                    keywordObject[0].search_volumes.push(frontendKeyword.search_volumes[svCounter])
                                }
                            }
                        }
                    }
                }
                let index = clipboardKeywords.findIndex((row) => row.keyword === keywordObject[0].keyword)
                clipboardKeywords[index].search_volumes = keywordObject[0].search_volumes
            }
        }
        return clipboardKeywords
    },
    getQuestionWord(question) {
        const questionParams = [
            { text: "wann", color: "green darken-3" },
            { text: "warum", color: "pink darken-4" },
            { text: "was", color: "teal darken-4" },
            { text: "welche", color: "deep-orange darken-4" },
            { text: "welchen", color: "deep-orange darken-4" },
            { text: "welcher", color: "deep-orange darken-4" },
            { text: "welches", color: "deep-orange darken-4" },
            { text: "wer", color: "purple darken-4" },
            { text: "wie", color: "indigo darken-4" },
            { text: "wo", color: "cyan darken-4" },
            { text: "wohin", color: "brown darken-2" }
        ]
        let param2 = { text: "-", color: "" }

        questionParams.map((param) => {
            let words = question.question.toLowerCase().split(" ")
            if (words.includes(param.text)) {
                param2 = param
            }
        })
        return param2
    },
    //exchange usd to euro and format it it to e.g. 1,98€
    exchangeUsdToEuro(number, exchangeRateFromComponent) {
        // exchangeRateFromComponent = optional
        let exchangeRate = undefined
        if (exchangeRateFromComponent) {
            exchangeRate = exchangeRateFromComponent
        } else {
            exchangeRate = store.state.rate_usd_to_eur
        }

        // console.log(number)
        // console.log(exchangeRate)
        if (number == undefined) {
            return "-"
        } else {
            var euro = number * exchangeRate
            var formattedEuro = this.formatEuro(euro)
            return formattedEuro
        }
    },
    formatNumberShort(num) {
        if (!num) return "-"
        if (num < 1000) return num

        let divider = "1"

        for (let index = 0; index < num.toString().length - 1; index++) {
            divider += "0"
        }
        divider = parseInt(divider)

        if (divider < 1000000) {
            return (num / 1000).toFixed(0) + "K"
        } else if (divider < 1000000000) {
            return (num / 1000000).toFixed(2) + "M"
        }
        return num
    },
    //format Number [10000 -> 10.000]
    formatNumber(number) {
        if (number == undefined) {
            return "-"
        } else {
            var formattedNumber = number.toLocaleString("de-DE", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            })
            return formattedNumber
        }
    },
    formatNumberWithFractions(number) {
        if (number == undefined) {
            return "-"
        } else {
            var formattedNumber = number.toLocaleString("de-DE", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })
            return formattedNumber
        }
    },
    //format Number [10000 -> 10.000]
    formatEuro(number) {
        if (number == undefined) {
            return "-"
        } else {
            var formattedNumber = number.toLocaleString("de-DE", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })
            return formattedNumber
        }
    },
    //remove Element from an Array by attribute
    removeElement(element, removeArray, attribute) {
        var newArray = removeArray.filter(function (obj) {
            return obj[attribute] !== element
        })
        return newArray
    },
    checkSelectedSizeForGraph(selected, allowedsize, graphdata) {
        var nodoubles = this.checkGraphDoubles(selected, graphdata)
        if (selected.length > allowedsize || graphdata.length > allowedsize || nodoubles.length + graphdata.length > allowedsize) {
            return false
        } else {
            return true
        }
    },
    getRandomRGBColor: function () {
        var min = Math.ceil(0)
        var max = Math.floor(255)
        var math1 = Math.floor(Math.random() * (max - min)) + min
        var math2 = Math.floor(Math.random() * (max - min)) + min
        var math3 = Math.floor(Math.random() * (max - min)) + min
        return "rgb(" + math1 + ", " + math2 + ", " + math3 + ")"
    },
    getGraphColor: function (competitor) {
        let competitors = ["titus", "planet sports", "skate deluxe", "skatepro"]
        let colorCodes = ["rgba(150, 108, 66,0.8)", "rgba(235, 64, 52,0.8)", "rgba(251, 0, 255,0.8)", "rgba(251, 3, 255,0.8)"]
        let arrayPosition = competitors.indexOf(competitor)
        if (arrayPosition === -1) {
            var min = Math.ceil(0)
            var max = Math.floor(255)
            var math1 = Math.floor(Math.random() * (max - min)) + min
            var math2 = Math.floor(Math.random() * (max - min)) + min
            var math3 = Math.floor(Math.random() * (max - min)) + min
            return "rgb(" + math1 + ", " + math2 + ", " + math3 + ")"
        } else {
            return colorCodes[arrayPosition]
        }
    },
    getRainbowColor(graphdata) {
        let colorCodes = [
            // "rgba(0, 0, 255,0.8)",
            // "rgba(255, 0, 0,0.8)",
            // "rgba(255, 165, 0,0.8)",
            // "rgba(0, 128, 0,0.8)",
            // "rgba(238, 130, 238,0.8)",
            // "rgba(75, 0, 130,0.8)",
            // "rgba(52, 209, 160,0.8)",
            // "rgba(255, 255, 0,0.8)",
            // "rgba(108, 133, 154,0.8)",
            // "rgba(169, 64, 103,0.8)",

            "rgba(178, 245, 91, 0.8)", //grün
            "rgba(91, 138, 99, 0.8)", //dunkelgrün
            "rgba(91, 245, 232, 0.8)", //türkis
            "rgba(91, 121, 245, 0.8)", //blau
            "rgba(245, 242, 91, 0.8)", //gelb
            "rgba(245, 157, 91, 0.8)", //orange
            "rgba(245, 91, 101, 0.8)", //rot
            "rgba(152, 91, 245, 0.8)", //dunkellila
            "rgba(135, 156, 176, 0.8)", //grau

            "rgba(224, 91, 245, 0.8)" //notfallfarbe falls kein overall lila bäh
        ]
        let graphObjects = []
        for (let graphdataCount = 0; graphdataCount < graphdata.length; graphdataCount++) {
            let object = {
                color: graphdata[graphdataCount].borderColor
            }
            graphObjects.push(object)
        }
        return colorCodes.filter((ar) => !graphObjects.find((rm) => rm.color === ar))
    },
    checkGraphDoubles(selected, graphdata) {
        let graphObjects = []
        for (let graphdataCount = 0; graphdataCount < graphdata.length; graphdataCount++) {
            let object = {
                keyword: graphdata[graphdataCount].label
            }
            graphObjects.push(object)
        }
        // //console.log(graphObjects)
        return selected.filter((ar) => !graphObjects.find((rm) => rm.keyword === ar.keyword))
    },
    checkKeywordsLength(input) {
        let invalid = false
        for (let inputCounter = 0; inputCounter < input.length; inputCounter++) {
            if (input[inputCounter].length > 80) {
                invalid = true
                break
            }
        }
        return invalid
    },
    createNotification(message, icon, color) {
        let obj = { show: true, message: message, icon: icon, color: color }
        return obj
    },
    setSettingsDownloadHeader(headers) {
        localStorage.setItem("downloadheaders", JSON.stringify(headers))
    },
    deleteDownloadColumns(headers) {
        let fields = []
        for (let index = 0; index < headers.length; index++) {
            if (headers[index].value !== "trend") {
                // if (headers[index].active) {
                if (!headers[index].name && headers[index].active) {
                    // all columns exceps sv array
                    fields.push({
                        label: headers[index].text,
                        value: headers[index].value,
                        dropdown: !headers[index].custom || !headers[index].customOptions || headers[index].customOptions.type !== "Dropdown" ? false : true
                    })
                } else {
                    if (headers[index].name) {
                        for (let columnIndex = 0; columnIndex < headers[index].columns.length; columnIndex++) {
                            if (headers[index].columns[columnIndex].active) {
                                fields.push({
                                    label: headers[index].columns[columnIndex].text,
                                    value: headers[index].columns[columnIndex].value
                                })
                            }
                        }
                    }
                }
                // }
            }
        }
        return fields
    },
    deleteDownloadAttributes(keywords) {
        for (let index = 0; index < keywords.length; index++) {
            delete keywords[index].search_volumes
        }
        return keywords
    },
    addCustoms(keywords, fields) {
        // get custom keys
        let keys = []
        for (let kwIndex = 0; kwIndex < keywords.length; kwIndex++) {
            let rowkeys = Object.keys(keywords[kwIndex].customs)
            keys = [...new Set([...keys, ...rowkeys])]
        }
        // let keys = Object.keys(keywords[0].customs)
        for (let keyIndex = 0; keyIndex < keys.length; keyIndex++) {
            let fieldIndex = fields.findIndex((x) => x.label == keys[keyIndex].substring(7))
            if (fieldIndex > -1) {
                if (fields[fieldIndex].dropdown) {
                    fields[fieldIndex].value = "customs." + keys[keyIndex] + ".text"
                } else {
                    fields[fieldIndex].value = "customs." + keys[keyIndex]
                }
            }
        }
        return fields
    },
    transformDataForExcelDownload(keywords, headers) {
        console.log(headers)
        let monthArray = ["", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
        let downloadRows = keywords.map((keywordRow) => {
            let row = {}
            row.Keyword = keywordRow.keyword
            let headerIndex = -1
            headerIndex = headers.findIndex((x) => x.value == "avgsv")
            if (headerIndex == -1) console.log(headerIndex, "avgsv")
            if (headers[headerIndex].active) row["Google Searches AVG MONTHLY"] = keywordRow.avgsv

            headerIndex = headers.findIndex((x) => x.value == "annualsv")
            if (headerIndex == -1) console.log(headerIndex, "annualsv")
            if (headers[headerIndex] && headers[headerIndex].active) row["Google Searches YEARLY"] = keywordRow.annualsv
            headerIndex = headers.findIndex((x) => x.value == "amazon_search_volume")
            if (headerIndex == -1) console.log(headerIndex, "amazon_search_volume")
            if (headers[headerIndex] && headers[headerIndex].active) row["Amazon Search Volume Yearly"] = keywordRow.amazon_search_volume
            headerIndex = headers.findIndex((x) => x.value == "cats")
            if (headerIndex == -1) console.log(headerIndex, "cats")
            if (headers[headerIndex].active) {
                // if (keywordRow.cats)
                row.Categories = keywordRow.cats
                    ? keywordRow.cats[keywordRow.active_cat_index][keywordRow.cats[keywordRow.active_cat_index].length - 1].category_name
                        ? keywordRow.cats[keywordRow.active_cat_index][keywordRow.cats[keywordRow.active_cat_index].length - 1].category_name
                        : null
                    : null // only one cat for donwload
            }

            headerIndex = headers.findIndex((x) => x.value == "adwords_cpc_high")
            if (headerIndex == -1) console.log(headerIndex, "adwords_cpc_high")
            if (headerIndex > -1) {
                if (headers[headerIndex].active) row["CPC Top Position (Upper Range)"] = this.exchangeUsdToEuro(keywordRow.adwords_cpc_high)
            }

            headerIndex = headers.findIndex((x) => x.value == "adwords_cpc_low")
            if (headerIndex == -1) console.log(headerIndex, "adwords_cpc_low")
            if (headerIndex > -1) {
                if (headers[headerIndex].active) row["CPC Top Position (Lower Range)"] = this.exchangeUsdToEuro(keywordRow.adwords_cpc_low)
            }

            headerIndex = headers.findIndex((x) => x.value == "adwords_competition")
            if (headerIndex == -1) console.log(headerIndex, "adwords_competition")
            if (headerIndex > -1) {
                if (headers[headerIndex].active) row["Adwords Competition"] = keywordRow.adwords_competition
            }

            headerIndex = headers.findIndex((x) => x.value == "keyword_difficulty")
            if (headerIndex == -1) console.log(headerIndex, "keyword_difficulty")
            if (headerIndex > -1) {
                if (headers[headerIndex].active) row["Keyword Difficulty"] = keywordRow.keyword_difficulty ? keywordRow.keyword_difficulty.difficulty : null
            }

            headerIndex = headers.findIndex((x) => x.value == "peak")
            if (headerIndex == -1) console.log(headerIndex, "peak")
            if (headerIndex > -1) {
                if (headers[headerIndex].active) row["Peak"] = keywordRow.peak
            }

            headerIndex = headers.findIndex((x) => x.value == "season")
            if (headerIndex == -1) console.log(headerIndex, "season")
            if (headerIndex > -1) {
                if (headers[headerIndex].active) row["Season"] = keywordRow.season ? keywordRow.season.season : null
            }

            headerIndex = headers.findIndex((x) => x.value == "serp_items")
            if (headerIndex == -1) console.log(headerIndex, "serp_items")
            if (headerIndex > -1) {
                if (headers[headerIndex].active) {
                    if (keywordRow.serp_items) {
                        let serpString = ""
                        keywordRow.serp_items.map((y, i) => (serpString += y.value += i == keywordRow.serp_items.length - 1 ? "" : ","))
                        row["SERP Items"] = serpString
                    } else {
                        row["SERP Items"] = null
                    }
                }
            }

            let svIndex = headers.findIndex((x) => x.name == "sv_headers")
            console.log("headers actve: " + headers[svIndex].active)
            for (let headerIndex = 0; headerIndex < headers[svIndex].columns.length; headerIndex++) {
                // if (headers[svIndex].active) {
                if (headers[svIndex].columns[headerIndex].text.substring(0, 8) == "Searches") {
                    if (headers[svIndex].columns[headerIndex].active) {
                        //All Searchvolume header start with 'Searches...'
                        let month = parseInt(headers[svIndex].columns[headerIndex].value.slice(-2))
                        let year = headers[svIndex].columns[headerIndex].value.substring(0, headers[svIndex].columns[headerIndex].value.length - 2)
                        let title = "Google_Searches_" + monthArray[month] + "_" + year
                        row[title] = keywordRow[headers[svIndex].columns[headerIndex].value] || 0
                    }
                }
                // }
            }
            // add custom headers + fields
            for (let headerIndex = 0; headerIndex < headers.length; headerIndex++) {
                if (headers[headerIndex].active) {
                    if (headers[headerIndex].custom) {
                        // console.log(headers[headerIndex])
                        // console.log(keywordRow.customs)
                        if (headers[headerIndex].customOptions.type !== "Dropdown") {
                            row[headers[headerIndex].text] = keywordRow.customs["custom_" + headers[headerIndex].text] ? keywordRow.customs["custom_" + headers[headerIndex].text] : ""
                        } else {
                            row[headers[headerIndex].text] = !keywordRow.customs["custom_" + headers[headerIndex].text]
                                ? ""
                                : keywordRow.customs["custom_" + headers[headerIndex].text].text
                                ? keywordRow.customs["custom_" + headers[headerIndex].text].text
                                : ""
                        }
                    }
                }
            }
            return row
        })
        return downloadRows
    },
    transformTrendsForExcelDownload(keywords, headers) {
        console.log(headers)
        let downloadRows = keywords.map((keywordRow) => {
            let row = {}
            row.Keyword = keywordRow.keyword
            let headerIndex = -1
            headerIndex = headers.findIndex((x) => x.value == "avgsv")
            if (headerIndex == -1) console.log(headerIndex, "avgsv")
            if (headers[headerIndex].active) row["Google Searches AVG MONTHLY"] = keywordRow.avgsv

            headerIndex = headers.findIndex((x) => x.value == "movingavg_short")
            if (headerIndex == -1) console.log(headerIndex, "movingavg_short")
            if (headers[headerIndex].active) {
                row[headers[headerIndex].text] = keywordRow.movingavg_short.toFixed(2) + " %"
            }

            headerIndex = headers.findIndex((x) => x.value == "lastYearMonth")
            if (headerIndex == -1) console.log(headerIndex, "lastYearMonth")
            if (headerIndex > -1) {
                row[headers[headerIndex].text] = keywordRow.lastYearMonth.count
            }

            headerIndex = headers.findIndex((x) => x.value == "latestYearMonth")
            if (headerIndex == -1) console.log(headerIndex, "latestYearMonth")
            if (headerIndex > -1) {
                row[headers[headerIndex].text] = keywordRow.latestYearMonth.count
            }

            headerIndex = headers.findIndex((x) => x.value == "monthChange")
            if (headerIndex == -1) console.log(headerIndex, "monthChange")
            if (headerIndex > -1) {
                row[headers[headerIndex].text] = keywordRow.monthChange
            }

            headerIndex = headers.findIndex((x) => x.value == "monthPercentChange")
            if (headerIndex == -1) console.log(headerIndex, "monthPercentChange")
            if (headerIndex > -1) {
                row[headers[headerIndex].text] = keywordRow.monthPercentChange
                    ? keywordRow.monthPercentChange.toFixed(2) + " %"
                    : keywordRow.lastYearMonth.count == 0 && keywordRow.latestYearMonth.count > 0
                    ? "∞"
                    : "0 %"
            }

            headerIndex = headers.findIndex((x) => x.value == "sumLastYear")
            if (headerIndex == -1) console.log(headerIndex, "sumLastYear")
            if (headerIndex > -1) {
                row[headers[headerIndex].text] = keywordRow.sumLastYear
            }

            headerIndex = headers.findIndex((x) => x.value == "sumLatestYear")
            if (headerIndex == -1) console.log(headerIndex, "sumLatestYear")
            if (headerIndex > -1) {
                row[headers[headerIndex].text] = keywordRow.sumLatestYear
            }

            headerIndex = headers.findIndex((x) => x.value == "diff")
            if (headerIndex == -1) console.log(headerIndex, "diff")
            if (headerIndex > -1) {
                row[headers[headerIndex].text] = keywordRow.diff
            }

            headerIndex = headers.findIndex((x) => x.value == "percent")
            if (headerIndex == -1) console.log(headerIndex, "percent")
            if (headerIndex > -1) {
                row[headers[headerIndex].text] = keywordRow.percent ? keywordRow.percent.toFixed(2) + " %" : keywordRow.sumLastYear == 0 && keywordRow.sumLatestYear > 0 ? "∞" : "0 %"
            }

            return row
        })
        return downloadRows
    },
    transformTrendsForCsvDownload(keywords) {
        keywords = keywords.map((x) => {
            x.movingavg_short = x.movingavg_short.toFixed(2) + " %"
            x.lastYearMonth = x.lastYearMonth.count
            x.latestYearMonth = x.latestYearMonth.count
            x.monthPercentChange = x.monthPercentChange ? x.monthPercentChange.toFixed(2) + " %" : x.lastYearMonth.count == 0 && x.latestYearMonth.count > 0 ? "" : "0 %"
            x.percent = x.percent ? x.percent.toFixed(2) + " %" : x.sumLastYear == 0 && x.sumLatestYear > 0 ? "" : "0 %"

            return x
        })
        return keywords
    },
    findNewestAndOldestDate(keywords) {
        let newestMonth = 0
        let newestYear = 0
        let oldestMonth = keywords[0].search_volumes[keywords[0].search_volumes.length - 1].month
        let oldestYear = parseInt(keywords[0].search_volumes[keywords[0].search_volumes.length - 1].year)
        for (let keywordCounter = 0; keywordCounter < keywords.length; keywordCounter++) {
            if (parseInt(keywords[keywordCounter].search_volumes[0].year) >= newestYear && keywords[keywordCounter].search_volumes[0].month > newestMonth) {
                newestYear = parseInt(keywords[keywordCounter].search_volumes[0].year)
                newestMonth = keywords[keywordCounter].search_volumes[0].month
            }
            if (
                parseInt(keywords[keywordCounter].search_volumes[keywords[keywordCounter].search_volumes.length - 1].year) <= oldestYear &&
                keywords[keywordCounter].search_volumes[keywords[keywordCounter].search_volumes.length - 1].month < oldestMonth
            ) {
                oldestYear = parseInt(keywords[keywordCounter].search_volumes[keywords[keywordCounter].search_volumes.length - 1].year)
                oldestMonth = keywords[keywordCounter].search_volumes[keywords[keywordCounter].search_volumes.length - 1].month
            }
        }
        return {
            newestMonth: newestMonth,
            newestYear: newestYear,
            oldestYear: oldestYear,
            oldestMonth: oldestMonth
        }
    },
    buildMonthCheckObject(startMonthFrontend, endMonthFrontend) {
        let checkObject = []
        for (let startMonth = parseInt(startMonthFrontend); startMonth < parseInt(endMonthFrontend) + 1; startMonth++) {
            checkObject.push({ month: startMonth, complete: true })

            let startMonthString = []
            startMonthString.push(startMonth.toString())
            let lastDigits = parseInt(startMonthString[0].slice(-2))
            if (lastDigits % 12 == 0) {
                startMonth = startMonth - 12 + 100
            }
        }
        return checkObject
    },
    checkRowsMonths(rows, startMonthFrontend, endMonthFrontend) {
        let monthCheckObject = this.buildMonthCheckObject(startMonthFrontend, endMonthFrontend)

        for (let rowCounter = 0; rowCounter < rows.length; rowCounter++) {
            // console.log("row", rowCounter)
            let monthIndex = 0
            for (let startMonth = parseInt(startMonthFrontend); startMonth < parseInt(endMonthFrontend) + 1; startMonth++) {
                // console.log("startMonth", startMonth)
                // console.log("monthIndex", monthIndex)
                // console.log(rows[rowCounter])
                if (rows[rowCounter][startMonth.toString()] == undefined) {
                    monthCheckObject[monthIndex].complete = false
                }

                monthIndex++
                let startMonthString = []
                startMonthString.push(startMonth.toString())
                let lastDigits = parseInt(startMonthString[0].slice(-2))
                if (lastDigits % 12 == 0) {
                    startMonth = startMonth - 12 + 100
                }
            }
        }
        return monthCheckObject
    },
    buildOverallGraph(rows, startMonthFrontend, endMonthFrontend, dataMonths) {
        // console.log(endMonthFrontend)
        let overallGraph = {
            label: "Sum of all keywords",
            backgroundColor: "#EB5E28",
            borderColor: "grey",
            pointBackgroundColor: "white",
            borderWidth: 2,
            pointBorderColor: "grey",
            data: [],
            hidden: false
        }
        let dataIndex = 0
        let firstcompletefound = false
        let actual_date = store.state.actual_date
        let endMonth = actual_date.split("/")[0]
        let endYear = actual_date.split("/")[1]
        let actual_date_number
        if (parseInt(endMonth) < 10) {
            actual_date_number = parseInt(endYear + "0" + endMonth)
        } else {
            actual_date_number = parseInt(endYear + "" + endMonth)
        }

        for (let startMonth = parseInt(startMonthFrontend); startMonth < actual_date_number + 1; startMonth++) {
            // console.log(dataIndex)
            // console.log(dataMonths[dataIndex].complete)
            // console.log(dataMonths[dataIndex].month)
            if ((firstcompletefound || dataMonths[dataIndex].complete) && startMonth < actual_date_number + 1) {
                firstcompletefound = true
                // console.log(dataMonths[dataIndex].month)
                for (let rowCounter = 0; rowCounter < rows.length; rowCounter++) {
                    if (!overallGraph.data[dataIndex]) overallGraph.data[dataIndex] = 0
                    overallGraph.data[dataIndex] += rows[rowCounter][startMonth] == undefined ? 0 : rows[rowCounter][startMonth]
                }
            } else {
                overallGraph.data[dataIndex] = null
            }
            dataIndex++
            let startMonthString = []
            startMonthString.push(startMonth.toString())
            let lastDigits = parseInt(startMonthString[0].slice(-2))
            if (lastDigits % 12 == 0) {
                startMonth = startMonth - 12 + 100
            }
        }
        // console.log(overallGraph)
        return overallGraph
    },
    buildGraphLabels(startMonthFrontend, endMonthFrontend) {
        let monthArray = ["", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
        let monthCounter = startMonthFrontend
        let newGraphLabels = []
        do {
            // console.log(monthCounter)
            let helpingArray = []
            helpingArray.push(monthCounter.toString())
            let monthNumber = parseInt(helpingArray[0].slice(-2))
            let yearNumber = monthCounter.toString().slice(0, -2)
            // console.log(monthNumber)
            // console.log(yearNumber)
            newGraphLabels.push(monthArray[monthNumber] + " " + yearNumber)
            monthCounter++
            if (parseInt(monthNumber) % 12 == 0) {
                monthCounter = monthCounter - 12 + 100
            }
        } while (monthCounter < endMonthFrontend + 1)
        return newGraphLabels
    },
    addToChart(graphdata, graphlabel, rows, selectedKeywords) {
        let graphKeywords = []
        for (let dataCounter = 0; dataCounter < graphdata.length; dataCounter++) {
            graphKeywords.push(graphdata[dataCounter].label)
        }
        let rowGraphKeywords = rows.filter((row) => {
            if (graphKeywords.indexOf(row.keyword) > -1) return row
        })
        let newGraphKeywords = rowGraphKeywords.concat(selectedKeywords)
        let newGraphObjects = this.buildGraphObjects(newGraphKeywords, rows, graphdata, graphlabel)
        return newGraphObjects
    },
    buildGraphObjects(graphrows, rows, graphdata, graphlabel) {
        let filteredRows = rows.filter((row) => {
            let all_null = true
            row.search_volumes.map((x) => {
                // console.log(x)
                if (x.count !== undefined && x.count !== null && x.count !== 0) all_null = false
            })
            if (!all_null) return row
        })
        if (filteredRows.length) rows = filteredRows
        console.log("GRAPHROWN")
        console.log(rows)

        let startMonthFrontend = ""
        let endMonthFrontend = ""
        let newestAndOldestDate = {}
        if (graphrows.length > 0) {
            // console.log(graphrows)
            newestAndOldestDate = this.findNewestAndOldestDate(graphrows)
        } else {
            newestAndOldestDate = this.findNewestAndOldestDate(rows)
        }

        if (newestAndOldestDate.oldestMonth < 10) {
            startMonthFrontend = parseInt(newestAndOldestDate.oldestYear + "0" + newestAndOldestDate.oldestMonth)
        } else {
            startMonthFrontend = parseInt(newestAndOldestDate.oldestYear + "" + newestAndOldestDate.oldestMonth)
        }
        if (newestAndOldestDate.newestMonth < 10) {
            endMonthFrontend = parseInt(newestAndOldestDate.newestYear + "0" + newestAndOldestDate.newestMonth)
        } else {
            endMonthFrontend = parseInt(newestAndOldestDate.newestYear + "" + newestAndOldestDate.newestMonth)
        }
        let dataMonths = this.checkRowsMonths(rows, startMonthFrontend, endMonthFrontend)
        let actual_date = store.state.actual_date
        let endMonth = actual_date.split("/")[0]
        let endYear = actual_date.split("/")[1]
        let actual_date_number
        if (parseInt(endMonth) < 10) {
            actual_date_number = parseInt(endYear + "0" + endMonth)
        } else {
            actual_date_number = parseInt(endYear + "" + endMonth)
        }
        if (graphrows.length < 1) {
            dataMonths = dataMonths.filter((entry) => {
                if (entry.complete) return entry
            })
            startMonthFrontend = dataMonths[0].month
            endMonthFrontend = dataMonths[dataMonths.length - 1].month
            graphlabel = this.buildGraphLabels(startMonthFrontend, actual_date_number)
        } else {
            graphlabel = this.buildGraphLabels(startMonthFrontend, actual_date_number)
        }

        graphdata = []
        let overallGraph = this.buildOverallGraph(rows, startMonthFrontend, endMonthFrontend, dataMonths)
        graphdata.push(overallGraph)

        for (let rowIndex = 0; rowIndex < graphrows.length; rowIndex++) {
            let color = this.getRainbowColor(graphdata)
            let newData = {
                label: graphrows[rowIndex].keyword,
                backgroundColor: "rgba(0, 0, 0, 0)",
                borderColor: color[0],
                pointBackgroundColor: "white",
                borderWidth: 3,
                pointBorderColor: "grey",
                data: []
            }
            // console.log(startMonthFrontend)
            // console.log(endMonthFrontend)

            //add missing months to new row
            let rankCounter = 1
            for (let startMonth = parseInt(startMonthFrontend); startMonth < parseInt(endMonthFrontend) + 1; startMonth++) {
                let graphStartMonthBackwards = 0
                // console.log(rowIndex)
                // console.log(graphrows[rowIndex].search_volumes)
                // console.log(graphrows[rowIndex].search_volumes.length-rankCounter)
                // console.log(startMonth)
                // console.log(endMonthFrontend)
                if (!graphrows[rowIndex].search_volumes[graphrows[rowIndex].search_volumes.length - rankCounter]) {
                    newData.data.push(null)
                } else {
                    if (graphrows[rowIndex].search_volumes[graphrows[rowIndex].search_volumes.length - rankCounter].month < 10) {
                        graphStartMonthBackwards = parseInt(
                            graphrows[rowIndex].search_volumes[graphrows[rowIndex].search_volumes.length - rankCounter].year +
                                "0" +
                                graphrows[rowIndex].search_volumes[graphrows[rowIndex].search_volumes.length - rankCounter].month
                        )
                    } else {
                        graphStartMonthBackwards = parseInt(
                            graphrows[rowIndex].search_volumes[graphrows[rowIndex].search_volumes.length - rankCounter].year +
                                "" +
                                graphrows[rowIndex].search_volumes[graphrows[rowIndex].search_volumes.length - rankCounter].month
                        )
                    }
                    if (graphStartMonthBackwards == startMonth) {
                        newData.data.push(graphrows[rowIndex].search_volumes[graphrows[rowIndex].search_volumes.length - rankCounter].count)

                        rankCounter++
                    } else {
                        newData.data.push(null)
                    }
                }
                let startMonthString = []
                startMonthString.push(startMonth.toString())
                let lastDigits = parseInt(startMonthString[0].slice(-2))
                if (lastDigits % 12 == 0) {
                    startMonth = startMonth - 12 + 100
                }
            }
            graphdata.push(newData)
        }
        return { graphdata: graphdata, graphlabel: graphlabel }
    },
    validateGoogleInput(input) {
        let filtered = input.filter((x) => {
            if (x.length < 81 && x.split(/\s+/).length < 11) {
                return x
            }
        })
        return filtered
    },
    formatRelativeDate(date) {
        const now = new Date()
        const commentDate = new Date(date)
        const diffInMilliseconds = now - commentDate

        // Define thresholds for relative time
        const minute = 60 * 1000
        const hour = 60 * minute
        const day = 24 * hour
        const week = 7 * day

        if (diffInMilliseconds < minute) {
            return "a few seconds ago"
        } else if (diffInMilliseconds < hour) {
            const minutes = Math.floor(diffInMilliseconds / minute)
            return `${minutes} minute${minutes > 1 ? "s" : ""} ago`
        } else if (diffInMilliseconds < day) {
            const hours = Math.floor(diffInMilliseconds / hour)
            return `${hours} hour${hours > 1 ? "s" : ""} ago`
        } else if (diffInMilliseconds < week) {
            const days = Math.floor(diffInMilliseconds / day)
            return `${days} day${days > 1 ? "s" : ""} ago`
        } else {
            return commentDate.toLocaleDateString() // Fallback to standard format
        }
    },
    validateUserInput(inputArray) {
        let errors = []
        inputArray.map((entry, index) => {
            if (entry.length > 80) {
                errors.push({ type: "not more than 80 characters per phrase", index: index, keyword: entry })
            } else if (entry.split(/\s+/).length > 10) {
                errors.push({ type: "not more than 10 words per phrase", index: index, keyword: entry })
            }
        })
        return errors
    },
    validateSerpApiKeywords(inputArray) {
        const errors = []

        inputArray.forEach((entry, index) => {
            if (entry.length > 700) {
                errors.push({ type: "not more than 700 characters per keyword", index, keyword: entry })
            }
        })
        return errors
    },
    replaceCharactersForSerpAPI(inputArray) {
        // Liste der zu entfernenden Premium-Parameter (case-insensitive)
        const premiumParams = [
            "allinanchor:",
            "allintext:",
            "allintitle:",
            "allinurl:",
            "define:",
            "filetype:",
            "id:",
            "inanchor:",
            "info:",
            "intext:",
            "intitle:",
            "inurl:",
            "link:",
            "site:",
            "cache:"
        ]
        // Regex für alle Premium-Parameter und cache:
        const premiumRegex = new RegExp(premiumParams.join("|"), "gi")

        return inputArray.map((entry) => {
            // Ersetze % durch %25 und + durch %2B
            // let replaced = entry.replace(/%/g, "%25").replace(/\+/g, "%2B")
            // Entferne alle Premium-Parameter und cache:
            let replaced = entry.replace(premiumRegex, "")
            // Überflüssige Leerzeichen entfernen
            replaced = replaced.replace(/\s{2,}/g, " ").trim()
            return replaced
        })
    },
    replaceSpecialCharacters(inputArray, replacer = " ") {
        try {
            var regExp =
                /[\u0000-\u001F]|[\u0021]|[\u0025]|[\u0028-\u002A]|[\u002C]|[\u003B-\u0040]|[\u005C]|[\u00A7]|[\u005E]|[\u0060]|[\u00B0]|[\u007B-\u009F]|[\u00A1-\u00A2]|[\u00A4-\u00A9]|[\u00AB-\u00B4]|[\u00B6]|[\u00B8-\u00B9]|[\u00BB-\u00BF]|[\u00D7]|[\u00F7]|[\u0250-\u0258]|[\u025A-\u02AF]|[\u02C2-\u02C5]|[\u02D2-\u02DF]|[\u02E5-\u02EB]|[\u02ED]|[\u02EF-\u02FF]|[\u0375]|[\u037E]|[\u0384-\u0385]|[\u0387]|[\u03F6]|[\u0482]|[\u0488-\u0489]|[\u055A-\u0560]|[\u0588-\u058F]|[\u05BE]|[\u05C0]|[\u05C3]|[\u05C6]|[\u05EF]|[\u05F3-\u060F]|[\u061B-\u061F]|[\u066A-\u066D]|[\u06D4]|[\u06DD-\u06DE]|[\u06E9]|[\u06FD-\u06FE]|[\u0700-\u070F]|[\u07F6-\u07F9]|[\u07FD-\u07FF]|[\u0830-\u083E]|[\u085E]|[\u0870-\u089F]|[\u08B5]|[\u08BE-\u08D3]|[\u08E2]|[\u0964-\u0965]|[\u0970]|[\u09F2-\u09FB]|[\u09FD-\u09FE]|[\u0A76]|[\u0AF0-\u0AF1]|[\u0B55]|[\u0B70]|[\u0B72-\u0B77]|[\u0BF0-\u0BFA]|[\u0C04]|[\u0C3C]|[\u0C5D]|[\u0C77-\u0C7F]|[\u0C84]|[\u0CDD]|[\u0D04]|[\u0D4F]|[\u0D58-\u0D5E]|[\u0D70-\u0D79]|[\u0D81]|[\u0DF4]|[\u0E3F]|[\u0E4F]|[\u0E5A-\u0E5B]|[\u0E86]|[\u0E89]|[\u0E8C]|[\u0E8E-\u0E93]|[\u0E98]|[\u0EA0]|[\u0EA8-\u0EA9]|[\u0EAC]|[\u0EBA]|[\u0F01-\u0F17]|[\u0F1A-\u0F1F]|[\u0F2A-\u0F34]|[\u0F36]|[\u0F38]|[\u0F3A-\u0F3D]|[\u0F85]|[\u0FBE-\u0FC5]|[\u0FC7-\u0FDA]|[\u104A-\u104F]|[\u109E-\u109F]|[\u10FB]|[\u1360-\u137C]|[\u1390-\u1399]|[\u1400]|[\u166D-\u166E]|[\u169B-\u169C]|[\u16EB-\u16ED]|[\u170D]|[\u1715-\u171F]|[\u1735-\u1736]|[\u17D4-\u17D6]|[\u17D8-\u17DB]|[\u17F0-\u180A]|[\u180E-\u180F]|[\u1878]|[\u1940-\u1945]|[\u19DA-\u19FF]|[\u1A1E-\u1A1F]|[\u1AA0-\u1AA6]|[\u1AA8-\u1AAD]|[\u1ABE-\u1ACE]|[\u1B4C]|[\u1B5A-\u1B6A]|[\u1B74-\u1B7E]|[\u1BFC-\u1BFF]|[\u1C3B-\u1C3F]|[\u1C7E-\u1C7F]|[\u1C90-\u1CC7]|[\u1CD3]|[\u1CFA]|[\u1DFA]|[\u1FBD]|[\u1FBF-\u1FC1]|[\u1FCD-\u1FCF]|[\u1FDD-\u1FDF]|[\u1FED-\u1FEF]|[\u1FFD-\u1FFE]|[\u200B-\u2027]|[\u202A-\u202E]|[\u2030-\u203E]|[\u2041-\u2053]|[\u2055-\u205E]|[\u2060-\u2070]|[\u2074-\u207E]|[\u2080-\u208E]|[\u20A0-\u20AB]|[\u20AD-\u20C0]|[\u20DD-\u20E0]|[\u20E2-\u20E4]|[\u2100-\u2101]|[\u2103-\u2106]|[\u2108-\u2109]|[\u2114]|[\u2116-\u2118]|[\u211E-\u2123]|[\u2125]|[\u2127]|[\u2129]|[\u212E]|[\u213A-\u213B]|[\u2140-\u2144]|[\u214A-\u214D]|[\u214F-\u2169]|[\u2170-\u2179]|[\u2189-\u2BFF]|[\u2C2F]|[\u2C5F]|[\u2CE5-\u2CEA]|[\u2CF9-\u2CFF]|[\u2D70]|[\u2E00-\u2E2E]|[\u2E30-\u2FFB]|[\u3001-\u3004]|[\u3006-\u3020]|[\u3030]|[\u3036-\u3037]|[\u303D-\u303F]|[\u309B-\u309C]|[\u30A0]|[\u30FD-\u30FE]|[\u312F]|[\u3190-\u319F]|[\u31BB-\u31E3]|[\u3200-\u33FF]|[\u4DBF-\u4DFF]|[\u9FFF]|[\uA490-\uA4C6]|[\uA4FE-\uA4FF]|[\uA60D-\uA60F]|[\uA670-\uA673]|[\uA67E]|[\uA6F2-\uA716]|[\uA720-\uA721]|[\uA789-\uA78A]|[\uA7AF]|[\uA7B8-\uA7F6]|[\uA828-\uA839]|[\uA874-\uA877]|[\uA8CE-\uA8CF]|[\uA8F8-\uA8FA]|[\uA8FC]|[\uA8FE-\uA8FF]|[\uA92E-\uA92F]|[\uA95F]|[\uA9C1-\uA9CD]|[\uA9DE-\uA9DF]|[\uAA5C-\uAA5F]|[\uAA77-\uAA79]|[\uAADE-\uAADF]|[\uAAF0-\uAAF1]|[\uAB5B]|[\uAB66-\uAB6B]|[\uABEB]|[\uE000-\uF8FF]|[\uFA0E-\uFA0F]|[\uFA11]|[\uFA13-\uFA15]|[\uFA1F-\uFA21]|[\uFA23-\uFA24]|[\uFA27-\uFA29]|[\uFB00-\uFB06]|[\uFB29]|[\uFBB2-\uFBC2]|[\uFD3E-\uFD4F]|[\uFDCF]|[\uFDFC-\uFDFF]|[\uFE10-\uFE19]|[\uFE30-\uFE32]|[\uFE35-\uFE4C]|[\uFE50-\uFE6B]|[\uFEFF-\uFF05]|[\uFF07-\uFF0A]|[\uFF0C-\uFF0F]|[\uFF1A-\uFF20]|[\uFF3B-\uFF3E]|[\uFF40]|[\uFF5B-\uFFFD]|[\u{104A0}-\u{104FB}]|[\u{109E0}-\u{109FF}]|[\u{10C80}-\u{10CCF}]|[\u{10CE0}-\u{10CFF}]|[\u{10FB0}-\u{10FBF}]|[\u{12490}-\u{1249F}]|[\u{124E0}-\u{124FF}]|[\u{13110}-\u{1311F}]|[\u{13160}-\u{1317F}]|[\u{169B0}-\u{169FF}]|[\u{16F90}-\u{16FF1}]|[\u{187F7}]|[\u{18AB0}-\u{18AC7}]|[\u{18AC8}-\u{18AFF}]|[\u{1AFF0}-\u{1AFFE}]|[\u{1CFA0}-\u{1CFC3}]|[\u{1F160}-\u{1F17F}]|[\u{1F1E6}-\u{1F1FF}]|[\u{1F300}-\u{1F5FF}]|[\u{1F460}-\u{1F47F}]|[\u{1F4E0}-\u{1F4FF}]|[\u{1F580}-\u{1F58F}]|[\u{1F5A0}-\u{1F5AF}]|[\u{1F5C0}-\u{1F5CF}]|[\u{1F5E0}-\u{1F5EF}]|[\u{1F600}-\u{1F64F}]|[\u{1F680}-\u{1F6FF}]|[\u{1F7E0}-\u{1F7F0}]|[\u{1F900}-\u{1F9FF}]|[\u{1FA00}-\u{1FA6F}]|[\u{1FA70}-\u{1FAFF}]|[\u{1FB50}-\u{1FB5F}]|[\u{1FBF0}-\u{1FBF9}]|[\u{2A6DF}-\u{2F80F}]|[\u{2F810}-\u{2F843}]|[\u{2F844}-\u{2FA1D}]|[\u{E0001}-\u{FFFFD}]/gu
            let cleanArray = inputArray.map((entry) => {
                // if (entry.match(regExp)) {
                //     console.log(entry)
                // }
                entry = entry.replaceAll(regExp, replacer)
                entry = entry.trim()
                if (entry[0] == "-") {
                    entry = entry.replace("-", "")
                }
                return entry
            })
            return cleanArray
        } catch (error) {
            console.log(error)
            return inputArray
        }
    },
    filterKeywordTable(unfilteredKeywords) {
        let filteredKeywords = []
        console.log(unfilteredKeywords[0])
        unfilteredKeywords.map((keyword) => {
            let foundFilterKw = 0
            store.state.active_filter.map((single_filter) => {
                if (single_filter.field.id == 1) {
                    // keyword
                    let keywords = single_filter.value.split(",")
                    if (single_filter.action.value == "includes") {
                        let filterfound = 0
                        keywords.forEach((input) => {
                            if (keyword.keyword.includes(input.trim().toLowerCase())) {
                                filterfound++
                            }
                        })
                        if (filterfound) foundFilterKw++
                        // if (keyword.keyword.includes(single_filter.value)) foundFilterKw++
                    } else if (single_filter.action.value == "excludes") {
                        if (keywords.every((input) => !keyword.keyword.includes(input.trim().toLowerCase()))) foundFilterKw++
                    } else if (single_filter.action.value == "like") {
                        let filterfound = 0
                        keywords.forEach((input) => {
                            if (keyword.keyword == input.trim().toLowerCase()) {
                                filterfound++
                            }
                        })
                        if (filterfound) foundFilterKw++
                        // if (keyword.keyword == single_filter.value) foundFilterKw++
                    } else if (single_filter.action.value == "not_like") {
                        let filterfound = 0
                        keywords.forEach((input) => {
                            if (keyword.keyword !== input.trim().toLowerCase()) {
                                filterfound++
                            }
                        })
                        if (filterfound == keywords.length) foundFilterKw++
                        // if (keyword.keyword !== single_filter.value) foundFilterKw++
                    } else {
                        console.log("error")
                    }
                } else if (single_filter.field.id == 2) {
                    // search volume
                    if (single_filter.action.value == "<") {
                        if (keyword.avgsv < single_filter.value) foundFilterKw++
                    } else if (single_filter.action.value == ">") {
                        if (keyword.avgsv > single_filter.value) foundFilterKw++
                    } else if (single_filter.action.value == "=") {
                        if (keyword.avgsv == single_filter.value) foundFilterKw++
                    } else {
                        console.log("error")
                    }
                } else if (single_filter.field.id == 3) {
                    // cats
                    if (single_filter.action.value == "includes") {
                        if (keyword.cats) {
                            let catsofKeyword = keyword.cats[keyword.active_cat_index]
                            if (catsofKeyword) {
                                single_filter.value.forEach((catforfilter) => {
                                    if (catsofKeyword[catsofKeyword.length - 1].category_name == catforfilter.category_name) {
                                        foundFilterKw++
                                    }
                                })
                            }
                        } else if (!keyword.cats) {
                            let findemptycat = single_filter.value.find((x) => x.category_name == "-")
                            if (findemptycat) foundFilterKw++
                        }
                    } else if (single_filter.action.value == "excludes") {
                        if (keyword.cats) {
                            let catsofKeyword = keyword.cats[keyword.active_cat_index]
                            let filterfound = 0
                            if (catsofKeyword) {
                                single_filter.value.forEach((catforfilter) => {
                                    if (catsofKeyword[catsofKeyword.length - 1].category_name !== catforfilter.category_name) {
                                        filterfound++
                                    }
                                })
                                if (filterfound == single_filter.value.length) foundFilterKw++
                            }
                        } else if (!keyword.cats) {
                            let findemptycat = single_filter.value.find((x) => x.category_name == "-")
                            if (findemptycat == undefined) foundFilterKw++
                        }
                    } else {
                        console.log("error")
                    }
                } else if (single_filter.field.id == 4) {
                    // cpc lower range
                    // console.log(parseFloat(keyword.adwords_cpc_high), parseFloat(single_filter.value))
                    if (single_filter.action.value == "<") {
                        if (keyword.adwords_cpc_low < parseFloat(single_filter.value)) foundFilterKw++
                    } else if (single_filter.action.value == ">") {
                        if (keyword.adwords_cpc_low > parseFloat(single_filter.value)) foundFilterKw++
                    } else if (single_filter.action.value == "=") {
                        if (keyword.adwords_cpc_low == parseFloat(single_filter.value)) foundFilterKw++
                    } else {
                        console.log("error")
                    }
                } else if (single_filter.field.id == 5) {
                    // cpc upper range
                    if (single_filter.action.value == "<") {
                        if (keyword.adwords_cpc_high < parseFloat(single_filter.value)) foundFilterKw++
                    } else if (single_filter.action.value == ">") {
                        if (keyword.adwords_cpc_high > parseFloat(single_filter.value)) foundFilterKw++
                    } else if (single_filter.action.value == "=") {
                        if (keyword.adwords_cpc_high == parseFloat(single_filter.value)) foundFilterKw++
                    } else {
                        console.log("error")
                    }
                } else if (single_filter.field.id == 6) {
                    // word count
                    if (single_filter.action.value == "<") {
                        // console.log(keyword.keyword.split(/\s+/).length, single_filter.value)
                        if (keyword.keyword.split(/\s+/).length < single_filter.value) foundFilterKw++
                    } else if (single_filter.action.value == ">") {
                        if (keyword.keyword.split(/\s+/).length > single_filter.value) foundFilterKw++
                    } else if (single_filter.action.value == "=") {
                        if (keyword.keyword.split(/\s+/).length == single_filter.value) foundFilterKw++
                    } else {
                        console.log("error")
                    }
                } else if (single_filter.field.id == 7) {
                    // SERP items
                    if (single_filter.action.value == "includes") {
                        if (keyword.serp_items) {
                            if (
                                single_filter.value
                                    .map((filter) => {
                                        return keyword.serp_items ? keyword.serp_items.some((serp_item) => serp_item.value === filter.value) : false
                                    })
                                    .includes(true)
                            )
                                foundFilterKw++
                        } else if (!keyword.serp_items) {
                            let findemptycat = single_filter.value.find((x) => x.value == "-")
                            if (findemptycat) foundFilterKw++
                        }
                    } else if (single_filter.action.value == "excludes") {
                        if (keyword.serp_items) {
                            let filterfound = 0
                            single_filter.value.forEach((filter) => {
                                filter.value
                                let serpIndex = keyword.serp_items.findIndex((x) => x.value == filter.value)
                                if (serpIndex == -1) filterfound++
                            })

                            if (filterfound == single_filter.value.length) foundFilterKw++
                        } else if (!keyword.serp_items) {
                            let findemptycat = single_filter.value.find((x) => x.value == "-")
                            if (findemptycat == undefined) foundFilterKw++
                        }
                    } else {
                        console.log("error")
                    }
                } else if (single_filter.field.id == 8) {
                    // sea competition
                    if (single_filter.action.value == "<") {
                        if (keyword.adwords_competition < single_filter.value) foundFilterKw++
                    } else if (single_filter.action.value == ">") {
                        if (keyword.adwords_competition > single_filter.value) foundFilterKw++
                    } else if (single_filter.action.value == "=") {
                        if (keyword.adwords_competition == single_filter.value) foundFilterKw++
                    } else {
                        console.log("error")
                    }
                } else if (single_filter.field.id == 9) {
                    // kw difficulty
                    if (single_filter.action.value == "<") {
                        if (!keyword.keyword_difficulty || keyword.keyword_difficulty.difficulty < single_filter.value) foundFilterKw++
                    } else if (single_filter.action.value == ">") {
                        if (keyword.keyword_difficulty && keyword.keyword_difficulty.difficulty > single_filter.value) foundFilterKw++
                    } else if (single_filter.action.value == "=") {
                        if (keyword.keyword_difficulty && keyword.keyword_difficulty.difficulty == single_filter.value) foundFilterKw++
                    } else {
                        console.log("error")
                    }
                } else if (single_filter.field.id == 10) {
                    // peak
                    if (single_filter.action.value == "includes") {
                        if (keyword.peak) {
                            single_filter.value.forEach((month) => {
                                if (keyword.peak == month) {
                                    foundFilterKw++
                                }
                            })
                        } else if (!keyword.peak) {
                            let findempty = single_filter.value.find((x) => x == "-")
                            if (findempty) foundFilterKw++
                        }
                    } else if (single_filter.action.value == "excludes") {
                        if (keyword.peak) {
                            let filterfound = 0
                            single_filter.value.forEach((month) => {
                                if (keyword.peak !== month) {
                                    filterfound++
                                }
                            })
                            if (filterfound == single_filter.value.length) foundFilterKw++
                        } else if (!keyword.peak) {
                            let findempty = single_filter.value.find((x) => x == "-")
                            if (findempty == undefined) foundFilterKw++
                        }
                    } else {
                        console.log("error")
                    }
                } else if (single_filter.field.id == 11) {
                    // season
                    if (single_filter.action.value == "includes") {
                        if (keyword.season && keyword.season.season) {
                            single_filter.value.forEach((season) => {
                                if (keyword.season.season == season) {
                                    foundFilterKw++
                                }
                            })
                        } else if (!keyword.season || !keyword.season.season) {
                            let findempty = single_filter.value.find((x) => x == "-")
                            if (findempty) foundFilterKw++
                        }
                    } else if (single_filter.action.value == "excludes") {
                        if (keyword.season && keyword.season.season) {
                            let filterfound = 0
                            single_filter.value.forEach((season) => {
                                if (keyword.season.season !== season) {
                                    filterfound++
                                }
                            })
                            if (filterfound == single_filter.value.length) foundFilterKw++
                        } else if (!keyword.season || !keyword.season.season) {
                            let findempty = single_filter.value.find((x) => x == "-")
                            if (findempty == undefined) foundFilterKw++
                        }
                    } else {
                        console.log("error")
                    }
                } else if (single_filter.field.custom) {
                    console.log("CUSTOM FILTER")
                    // customs
                    if (single_filter.action.value == "includes") {
                        if (keyword.customs) {
                            // console.log(keyword.customs[filterKey])
                            single_filter.value.map((filter) => {
                                if (keyword.customs["custom_" + single_filter.field.text] && filter.text == keyword.customs["custom_" + single_filter.field.text].text) foundFilterKw++
                            })
                        } else if (!keyword.customs) {
                            let findemptycat = single_filter.value.find((x) => x.value == "-")
                            if (findemptycat) foundFilterKw++
                        }
                    } else if (single_filter.action.value == "excludes") {
                        if (keyword.customs) {
                            let filterfound = 0
                            single_filter.value.map((filter) => {
                                if (keyword.customs["custom_" + single_filter.field.text] && filter.text !== keyword.customs["custom_" + single_filter.field.text].text) filterfound++
                            })
                            if (filterfound == single_filter.value.length) foundFilterKw++
                        } else if (!keyword.customs) {
                            let findemptycat = single_filter.value.find((x) => x.value == "-")
                            if (findemptycat == undefined) foundFilterKw++
                        }
                    } else {
                        console.log("error")
                    }
                } else {
                    console.log("error")
                }
            })
            if (foundFilterKw == store.state.active_filter.length) filteredKeywords.push(keyword)
        })
        return filteredKeywords
    },
    globalSort(items, index, isDesc, tableheader, optional_data = [], page = undefined) {
        if (!index[0]) return items
        const clickedHeader = tableheader.filter((header) => header.value == index[0])
        optional_data = JSON.parse(JSON.stringify(optional_data))
        // let relevanceData = {
        //     maxWDF: 0,
        //     minWDF: 0,
        //     minURLCoverage: 0,
        //     maxURLCoverage: 0,
        //     minPlacementValue: 0,
        //     maxPlacementValue: 0
        // }

        // console.log(items[0])
        // if (index[0] == "relevance") {
        //     relevanceData = optional_data
        //     // this.getRelevanceMinMaxValues(items)
        //     // console.log(relevanceData.minWDF)
        // }
        items.sort((a, b) => {
            // console.log(items[0])

            let a_object = JSON.parse(JSON.stringify(a))
            let b_object = JSON.parse(JSON.stringify(b))
            console.log(index[0])
            console.log(a_object[index[0]])

            if (page) {
                if (
                    page == "monitoring_categories" &&
                    index[0] !== "category" &&
                    index[0] !== "keyword_count" &&
                    index[0] !== "monthly_searches" &&
                    index[0] !== "movingavg_short" &&
                    index[0] !== "movingavg_long" &&
                    index[0] !== "avg_search_volume" &&
                    index[0] !== "latest_12_month_search_volume" &&
                    index[0] !== "prev_12_month_search_volume"
                ) {
                    console.log(a_object)
                    console.log(index[0])
                    let domain = index[0].split("_")[1].substring(0, index[0].split("_")[1].length - 6)
                    console.log(domain)
                    let compData = a_object.competitorData.find((entry) => entry.domain == domain)
                    // check if no comp entry or only one date

                    if (!compData) {
                        a_object[index[0]] = 0
                    } else if (!optional_data.date || !optional_data.date_old) {
                        a_object[index[0]] = compData.visibility[0] ? compData.visibility[0].value : 0
                    } else {
                        let visibData = compData.visibility.find((entry) => entry.date == optional_data.date)
                        let visibDataOld = compData.visibility.find((entry) => entry.date == optional_data.date_old)

                        if (visibDataOld !== undefined && visibData !== undefined) {
                            if (visibDataOld.value == 0 && visibData.value == 0) {
                                a_object[index[0]] = 0
                            } else if (visibDataOld.value == 0) {
                                a_object[index[0]] = visibData.value
                            } else if (visibData.value == 0) {
                                a_object[index[0]] = visibData.value
                            } else {
                                let change = ((visibData.value - visibDataOld.value) / visibDataOld.value) * 100
                                a_object[index[0]] = visibData.value
                            }
                        } else if (visibDataOld !== undefined) {
                            let change = -100 // Consider this a large negative change for "lost" status
                            a_object[index[0]] = 0
                        } else if (visibData !== undefined) {
                            let change = 100 // Consider this a large positive change for "new" status
                            a_object[index[0]] = visibData.value
                        } else {
                            a_object[index[0]] = 0
                        }
                    }
                    compData = b_object.competitorData.find((entry) => entry.domain == domain)

                    // check if no comp entry or only one date
                    if (!compData) {
                        b_object[index[0]] = 0
                    } else if (!optional_data.date || !optional_data.date_old) {
                        b_object[index[0]] = compData.visibility[0] ? compData.visibility[0].value : 0
                    } else {
                        let visibData = compData.visibility.find((entry) => entry.date == optional_data.date)
                        let visibDataOld = compData.visibility.find((entry) => entry.date == optional_data.date_old)

                        if (visibDataOld !== undefined && visibData !== undefined) {
                            if (visibDataOld.value == 0 && visibData.value == 0) {
                                b_object[index[0]] = 0
                            } else if (visibDataOld.value == 0) {
                                b_object[index[0]] = visibData.value
                            } else if (visibData.value == 0) {
                                b_object[index[0]] = visibData.value
                            } else {
                                let change = ((visibData.value - visibDataOld.value) / visibDataOld.value) * 100
                                b_object[index[0]] = visibData.value
                            }
                        } else if (visibDataOld !== undefined) {
                            let change = -100 // Consider this a large negative change for "lost" status
                            b_object[index[0]] = 0
                        } else if (visibData !== undefined) {
                            let change = 100 // Consider this a large positive change for "new" status
                            b_object[index[0]] = visibData.value
                        } else {
                            b_object[index[0]] = 0
                        }
                    }
                } else if (page == "monitoring_categories" && index[0] == "category") {
                    let catParts_a = a_object.category_id.split(";")
                    a_object[index[0]] = catParts_a[catParts_a.length - 1]

                    let catParts_b = b_object.category_id.split(";")
                    b_object[index[0]] = catParts_b[catParts_b.length - 1]
                    console.log(a_object[0])
                } else if (page == "monitoring_categories" && index[0] === "monthly_searches") {
                    // Der letzte Eintrag ist immer der aktuellste!
                    a_object[index[0]] = a_object.monthly_searches && a_object.monthly_searches.length ? a_object.monthly_searches[a_object.monthly_searches.length - 1].volume || 0 : 0
                    b_object[index[0]] = b_object.monthly_searches && b_object.monthly_searches.length ? b_object.monthly_searches[b_object.monthly_searches.length - 1].volume || 0 : 0
                } else if (page == "research_trends" && (index[0] == "lastYearMonth" || index[0] == "latestYearMonth")) {
                    console.log("HEEEER")
                    a_object[index[0]] = a_object[index[0]].count
                    b_object[index[0]] = b_object[index[0]].count
                } else {
                    // Normal object initialization
                    a_object[index[0]] = a_object[index[0]] ? a_object[index[0]] : 0
                    b_object[index[0]] = b_object[index[0]] ? b_object[index[0]] : 0
                }
            } else {
                // Filter object initialization
                if (index[0] == "contentscore") {
                    // CS - Projects
                    a_object[index[0]] = a_object.editor ? a_object.editor.content_score : 0
                    b_object[index[0]] = b_object.editor ? b_object.editor.content_score : 0
                } else if (index[0] == "competitors") {
                    // CS - Projects
                    a_object[index[0]] = a_object[index[0]].filter((e) => e.selected).length
                    b_object[index[0]] = b_object[index[0]].filter((e) => e.selected).length
                } else if (index[0] == "editor") {
                    // CS - Projects
                    a_object[index[0]] = a_object.editor ? a_object.editor.word_count : 0
                    b_object[index[0]] = b_object.editor ? b_object.editor.word_count : 0
                } else if (index[0] == "created") {
                    // CS - Projects
                    a_object[index[0]] = new Date(parseInt(a_object._id.toString().slice(0, 8), 16) * 1000)
                    b_object[index[0]] = new Date(parseInt(b_object._id.toString().slice(0, 8), 16) * 1000)
                } else if (index[0] == "question_word") {
                    // CS - Briefing
                    let param2 = { text: "-", color: "" }

                    optional_data.map((param) => {
                        let words = a_object.question.toLowerCase().split(" ")
                        if (words.includes(param.text)) {
                            param2 = param
                        }
                    })
                    a_object[index[0]] = param2.text

                    optional_data.map((param) => {
                        let words = b_object.question.toLowerCase().split(" ")
                        if (words.includes(param.text)) {
                            param2 = param
                        }
                    })
                    b_object[index[0]] = param2.text
                } else if (index[0] == "source") {
                    // CS - Briefing
                    let tags = a_object.tags
                    if (tags && tags[0] == "people_also_ask") {
                        a_object[index[0]] = "Google SERP"
                    } else {
                        let obj = { text: "", color: "" }
                        if (!tags) {
                            obj.text = "Competitors Content"
                            return obj
                        }
                        tags.map((tag) => {
                            if (tag.substring(0, 1) == "h") {
                                obj.text = "Competitors " + tag
                            } else {
                                obj.text = "Competitors Content"
                            }
                        })
                        a_object[index[0]] = obj.text
                    }

                    tags = b_object.tags
                    if (tags && tags[0] == "people_also_ask") {
                        b_object[index[0]] = "Google SERP"
                    } else {
                        let obj = { text: "", color: "" }
                        if (!tags) {
                            obj.text = "Competitors Content"
                            return obj
                        }
                        tags.map((tag) => {
                            if (tag.substring(0, 1) == "h") {
                                obj.text = "Competitors " + tag
                            } else {
                                obj.text = "Competitors Content"
                            }
                        })
                        b_object[index[0]] = obj.text
                    }
                } else if (index[0] == "positions") {
                    // CS - Comp Analyse

                    if (a_object[index[0]].length) {
                        let sum = 0
                        optional_data.map((t) => {
                            let e = a_object[index[0]].find((e) => e.keyword == t.keyword)
                            sum += e ? e.position : 100
                        })
                        let avgpos = sum / optional_data.length
                        a_object.avgpos = avgpos

                        a_object[index[0]] = avgpos.toFixed(1)
                    } else {
                        a_object[index[0]] = 1000
                    }

                    if (b_object[index[0]].length) {
                        let sum = 0
                        optional_data.map((t) => {
                            let e = b_object[index[0]].find((e) => e.keyword == t.keyword)
                            sum += e ? e.position : 100
                        })
                        let avgpos = sum / optional_data.length
                        b_object.avgpos = avgpos

                        b_object[index[0]] = avgpos.toFixed(1)
                    } else {
                        b_object[index[0]] = 1000
                    }
                } else if (index[0] == "speed_index" || index[0] == "first_contentful_paint" || index[0] == "interactive" || index[0] == "largest_contentful_paint") {
                    // CS - Comp Analyse
                    a_object[index[0]] = a_object[index[0]] == undefined ? 0 : a_object[index[0]].substring(0, a_object[index[0]].length - 2)
                    a_object[index[0]] = parseFloat(a_object[index[0]])

                    b_object[index[0]] = b_object[index[0]] == undefined ? 0 : b_object[index[0]].substring(0, b_object[index[0]].length - 2)
                    b_object[index[0]] = parseFloat(b_object[index[0]])
                } else if (index[0] == "comp_relevance") {
                    // CS - Setup - SelectComps
                    let avalue = Math.ceil((100 - a_object.avgpos) * 1.12)

                    a_object[index[0]] = avalue > 100 ? 100 : avalue

                    let bvalue = Math.ceil((100 - b_object.avgpos) * 1.12)

                    b_object[index[0]] = bvalue > 100 ? 100 : bvalue
                    // let count = a_object.count
                    // let totalSERPs = optional_data.project.topics.filter((topic) => topic.selected).length
                    // let sum = 0
                    // for (let index = 0; index < totalSERPs; index++) {
                    //     let positionEntry = a_object.positions[index]
                    //     if (positionEntry) {
                    //         sum += positionEntry.position
                    //     } else {
                    //         sum += 100
                    //     }
                    // }
                    // let relevance = 150 - sum / totalSERPs
                    // if (relevance > 100) {
                    //     relevance = 100 - Math.random() * (totalSERPs - count) //add variance
                    // }
                    // a_object[index[0]] = Math.ceil(relevance)

                    // let countb = b_object.count
                    // let totalSERPsb = optional_data.project.topics.filter((topic) => topic.selected).length
                    // let sumb = 0
                    // for (let index = 0; index < totalSERPsb; index++) {
                    //     let positionEntryb = b_object.positions[index]
                    //     if (positionEntryb) {
                    //         sumb += positionEntryb.position
                    //     } else {
                    //         sumb += 100
                    //     }
                    // }
                    // let relevanceb = 150 - sumb / totalSERPsb
                    // if (relevanceb > 100) {
                    //     relevanceb = 100 - Math.random() * (totalSERPsb - countb) //add variance
                    // }
                    // b_object[index[0]] = Math.ceil(relevanceb)
                } else if (index[0] == "relevance") {
                    // CS - Setup - SelectKeywords

                    const urlCovWeight = 0.15
                    const wdfWeight = 0.6
                    const termWeight = 0.25

                    let normURLCov = a_object.url_coverage
                    let normTerm = (a_object.termplacementValue - optional_data.minPlacementValue) / (optional_data.maxPlacementValue - optional_data.minPlacementValue)
                    normTerm = normTerm > 0 ? Math.min(...[normTerm + 0.52, 1]) : 0 // every keyword with any placement starts at 52 percent
                    let normWDF = (a_object.avgWDF - optional_data.minWDF) / (optional_data.maxWDF - optional_data.minWDF)
                    let sum = normURLCov * urlCovWeight + normTerm * termWeight + normWDF * wdfWeight
                    a_object[index[0]] = Math.ceil(sum * 100)

                    let normURLCovb = b_object.url_coverage
                    let normTermb = (b_object.termplacementValue - optional_data.minPlacementValue) / (optional_data.maxPlacementValue - optional_data.minPlacementValue)
                    normTermb = normTermb > 0 ? Math.min(...[normTermb + 0.52, 1]) : 0 // every keyword with any placement starts at 52 percent
                    let normWDFb = (b_object.avgWDF - optional_data.minWDF) / (optional_data.maxWDF - optional_data.minWDF)
                    let sumb = normURLCovb * urlCovWeight + normTermb * termWeight + normWDFb * wdfWeight
                    b_object[index[0]] = Math.ceil(sumb * 100)
                } else if (index[0] == "avgWDFIDF") {
                    // CS - Setup - SelectKeywords
                    a_object[index[0]] = a_object.avgWDF ? a_object.avgWDF * a_object.idf.idf : 0
                    b_object[index[0]] = b_object.avgWDF ? b_object.avgWDF * b_object.idf.idf : 0
                } else if (index[0] == "idf") {
                    // CS - Setup - SelectKeywords
                    a_object[index[0]] = a_object[index[0]] ? a_object[index[0]].idf : 0
                    b_object[index[0]] = b_object[index[0]] ? b_object[index[0]].idf : 0
                } else if (index[0] == "word_count") {
                    // CS - Setup - SelectKeywords
                    a_object[index[0]] = a_object.keyword.split(" ").length
                    b_object[index[0]] = b_object.keyword.split(" ").length
                }
            }

            if (index[0].substring(0, 6) == "custom") {
                //  custom columns
                const clickedHeaderType = clickedHeader[0].customOptions.type
                let isnan = clickedHeaderType == "Dropdown" ? isNaN(a_object.customs[index[0]].text) : isNaN(a_object.customs[index[0]])
                if (!isnan) {
                    // String
                    if (!isDesc[0]) {
                        if (a_object.customs[index[0]] == undefined || a_object.customs[index[0]] == "") return 1
                        if (b_object.customs[index[0]] == undefined || b_object.customs[index[0]] == "") return -1
                        return clickedHeaderType == "Dropdown" ? a_object.customs[index[0]].text - b_object.customs[index[0]].text : a_object.customs[index[0]] - b_object.customs[index[0]]
                    } else {
                        if (a_object.customs[index[0]] == undefined || a_object.customs[index[0]] == "") return 1
                        if (b_object.customs[index[0]] == undefined || b_object.customs[index[0]] == "") return -1
                        return clickedHeaderType == "Dropdown" ? b_object.customs[index[0]].text - a_object.customs[index[0]].text : b_object.customs[index[0]] - a_object.customs[index[0]]
                    }
                } else {
                    // Number
                    if (!isDesc[0]) {
                        if (a_object.customs[index[0]] == undefined || a_object.customs[index[0]] == "") return 1
                        if (b_object.customs[index[0]] == undefined || b_object.customs[index[0]] == "") return -1
                        return clickedHeaderType == "Dropdown"
                            ? a_object.customs[index[0]].text < b_object.customs[index[0]].text
                                ? -1
                                : 1
                            : a_object.customs[index[0]] < b_object.customs[index[0]]
                            ? -1
                            : 1
                    } else {
                        if (a_object.customs[index[0]] == undefined || a_object.customs[index[0]] == "") return 1
                        if (b_object.customs[index[0]] == undefined || b_object.customs[index[0]] == "") return -1
                        return clickedHeaderType == "Dropdown"
                            ? b_object.customs[index[0]].text < a_object.customs[index[0]].text
                                ? -1
                                : 1
                            : b_object.customs[index[0]] < a_object.customs[index[0]]
                            ? -1
                            : 1
                    }
                }
            } else {
                //  standard columns
                console.log(a_object[index[0]])

                if (!isNaN(a_object[index[0]])) {
                    // Number
                    console.log(a_object[index[0]])
                    if (!isDesc[0]) {
                        return (!a_object[index[0]] || a_object[index[0]] == "-" ? 0 : a_object[index[0]]) - (!b_object[index[0]] || b_object[index[0]] == "-" ? 0 : b_object[index[0]])
                    } else {
                        return (!b_object[index[0]] || b_object[index[0]] == "-" ? 0 : b_object[index[0]]) - (!a_object[index[0]] || a_object[index[0]] == "-" ? 0 : a_object[index[0]])
                    }
                } else {
                    if (!isDesc[0]) {
                        return a_object[index[0]] < b_object[index[0]] ? -1 : 1
                    } else {
                        return b_object[index[0]] < a_object[index[0]] ? -1 : 1
                    }
                }
            }
        })
        return items
    },
    buildQuestionHeaders(questions) {
        let colors = [
            "#D32F2F",
            "#512DA8",
            "#0288D1",
            "#388E3C",
            "#F9A825",
            "#E64A19",
            "#C2185B",
            "#303F9F",
            "#0097A7",
            "#558B2F",
            "#FF8F00",
            "#5D4037",
            "#7B1FA2",
            "#1976D2",
            "#00796B",
            "#AFB42B",
            "#F57C00",
            "#546E7A"
        ]
        let questionsColumn = {
            active: true,
            sortable: true,
            group: 0,
            text: "Question",
            modifiedText: "Question",
            value: "custom_Question",
            tooltip: "",
            modifiedTooltip: "",
            align: "left",
            custom: true,
            filter_attributes: [],
            customOptions: {
                type: "Dropdown",
                entries: [
                    // { text: "-", color: { hex: "" }, id: 0 },
                    // { text: "das", color: { hex: "#d34eed" }, id: 1 },
                    // { text: "dass", color: { hex: "#fc8403" }, id: 2 },
                    // {
                    //     text: "der",
                    //     color: {
                    //         hex: "#D81B60"
                    //     },
                    //     id: 4
                    // },
                    // { text: "die", color: { hex: "#c2e5d6" }, id: 5 },
                    // { text: "wann", color: { hex: "#61c701" }, id: 6 },
                    // {
                    //     text: "was",
                    //     color: {
                    //         hex: "#6D4C41"
                    //     },
                    //     id: 7
                    // },
                    // { text: "welche", color: { hex: "#643bfc" }, id: 8 },
                    // { text: "welcher", color: { hex: "#43feb0" }, id: 9 },
                    // { text: "welches", color: { hex: "#704b6f" }, id: 10 },
                    // { text: "wer", color: { hex: "#4a4f9d" }, id: 11 },
                    // { text: "wie", color: { hex: "#d6a6b1" }, id: 12 },
                    // { text: "wo", color: { hex: "#011e5b" }, id: 13 },
                    // { text: "wohin", color: { hex: "#1c3cb8" }, id: 14 }
                ]
            }
        }

        for (let index = 0; index < questions.questionParams.length; index++) {
            questionsColumn.customOptions.entries.push({ text: questions.questionParams[index], color: { hex: colors[index] }, id: index + 1 })
        }
        questionsColumn.customOptions.entries.unshift({ text: "-", color: { hex: "" }, id: 0 })
        let prepositionColumn = {
            active: true,
            sortable: true,
            group: 0,
            text: "Preposition",
            modifiedText: "Preposition",
            value: "custom_Preposition",
            tooltip: "",
            modifiedTooltip: "",
            align: "left",
            custom: true,
            filter_attributes: [],
            customOptions: {
                type: "Dropdown",
                entries: [
                    // { text: "-", color: { hex: "" }, id: 0 },
                    // { text: "ähnlich", color: { hex: "#d34eed" }, id: 1 },
                    // { text: "an", color: { hex: "#fc8403" }, id: 2 },
                    // { text: "auf", color: { hex: "#95b815" }, id: 4 },
                    // { text: "bei", color: { hex: "#505ab7" }, id: 5 },
                    // { text: "bis", color: { hex: "#f1731d" }, id: 6 },
                    // { text: "für", color: { hex: "#a024c6" }, id: 7 },
                    // { text: "mit", color: { hex: "#f0adea" }, id: 8 },
                    // { text: "nach", color: { hex: "#fb6a6d" }, id: 9 },
                    // { text: "nahe", color: { hex: "#6f7da1" }, id: 10 },
                    // { text: "ohne", color: { hex: "#59f1f5" }, id: 11 },
                    // { text: "wie", color: { hex: "#3e842f" }, id: 12 },
                    // { text: "zu", color: { hex: "#9d732a" }, id: 13 }
                ]
            }
        }
        for (let index = 0; index < questions.prepositionParams.length; index++) {
            prepositionColumn.customOptions.entries.push({ text: questions.prepositionParams[index], color: { hex: colors[index] }, id: index + 1 })
        }
        prepositionColumn.customOptions.entries.unshift({ text: "-", color: { hex: "" }, id: 0 })

        let comparisonColumn = {
            active: true,
            sortable: true,
            group: 0,
            text: "Comparison",
            modifiedText: "Comparison",
            value: "custom_Comparison",
            tooltip: "",
            modifiedTooltip: "",
            align: "left",
            custom: true,
            filter_attributes: [],
            customOptions: {
                type: "Dropdown",
                entries: [
                    // { text: "-", color: { hex: "" }, id: 0 },
                    // { text: "gegen", color: { hex: "#d34eed" }, id: 1 },
                    // { text: "gleich", color: { hex: "#fc8403" }, id: 2 },
                    // { text: "oder", color: { hex: "#c5c36a" }, id: 4 },
                    // { text: "und", color: { hex: "#7b27f7" }, id: 5 },
                    // { text: "vs", color: { hex: "#639b01" }, id: 6 }
                ]
            }
        }
        for (let index = 0; index < questions.comparisonParams.length; index++) {
            comparisonColumn.customOptions.entries.push({ text: questions.comparisonParams[index], color: { hex: colors[index] }, id: index + 1 })
        }
        comparisonColumn.customOptions.entries.unshift({ text: "-", color: { hex: "" }, id: 0 })

        return { questions: questionsColumn, prepositions: prepositionColumn, comparisons: comparisonColumn }
    },
    returnResearchDate(date) {
        let dateSplits = date.split("/")
        let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
        return months[dateSplits[0] - 1] + " " + dateSplits[1]
    }
}
function levenshteinDistance(s1, s2) {
    if (!s1 || !s2) {
        return 100
    }
    const len1 = s1.length
    const len2 = s2.length
    const dp = Array(len1 + 1)
        .fill(0)
        .map(() => Array(len2 + 1).fill(0))

    for (let i = 0; i <= len1; i++) {
        for (let j = 0; j <= len2; j++) {
            if (i === 0) {
                dp[i][j] = j
            } else if (j === 0) {
                dp[i][j] = i
            } else {
                const cost = s1[i - 1] === s2[j - 1] ? 0 : 1
                dp[i][j] = Math.min(
                    dp[i - 1][j] + 1, // Deletion
                    dp[i][j - 1] + 1, // Insertion
                    dp[i - 1][j - 1] + cost // Substitution
                )
            }
        }
    }

    return dp[len1][len2]
}
function normalizeDomain(domain) {
    try {
        // Entferne Protokoll, falls vorhanden
        domain = domain.replace(/^https?:\/\//, "")
        // Entferne evtl. Pfad/Query/Hash
        domain = domain.split("/")[0].split("?")[0].split("#")[0]
        // Prüfe, ob bereits www. vorhanden ist
        if (!domain.startsWith("www.")) {
            domain = "www." + domain
        }
        return domain
    } catch (e) {
        return domain
    }
}

function normalizeComparableDomain(domain) {
    try {
        domain = String(domain || "")
            .toLowerCase()
            .replace(/^https?:\/\//, "")
            .split("/")[0]
            .split("?")[0]
            .split("#")[0]
            .trim()
        return domain.replace(/^www\./, "")
    } catch (e) {
        return String(domain || "")
            .toLowerCase()
            .replace(/^www\./, "")
    }
}

// Passwortrichtlinie fuer alle Passwortfelder der App (Register, SetPasswordLogin,
// ResetPassword, AdminPanel, admin/Panel). Als freie Funktionen definiert (nicht als
// Methoden auf dem Default-Export), weil passwordRule losgeloest als
// `:rules="[$helpers.passwordRule]"` an Vuetify uebergeben wird -- dabei geht die
// this-Bindung verloren, ein `this.irgendwas` darin wuerde zur Laufzeit einen Fehler
// werfen, den Vuetify beim Regel-Aufruf stillschweigend verschluckt (die Regel wirkt
// dann einfach nie). passwordPolicyText selbst steht oben vor dem Default-Export
// (const wird -- anders als function -- nicht nutzbar gehoisted, das Objekt liest
// den Wert sonst, bevor er gesetzt ist).

function checkPasswordPolicy(password) {
    password = password || ""
    return {
        length: password.length >= 12,
        uppercase: /[A-Z]/.test(password),
        lowercase: /[a-z]/.test(password),
        number: /[0-9]/.test(password),
        special: /[^A-Za-z0-9]/.test(password)
    }
}

function isPasswordValid(password) {
    let checks = checkPasswordPolicy(password)
    return checks.length && checks.uppercase && checks.lowercase && checks.number && checks.special
}

function passwordRule(password) {
    return isPasswordValid(password) || passwordPolicyText
}
